var _clipPath, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _filter, _g, _filter2, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountingOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 1200 1200",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1200,
    width: 1200,
    y: 0,
    x: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i1",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    x2: 444,
    y2: 0,
    x1: -438,
    y1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#68b2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5da7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#529bf7"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i2",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    x2: 23,
    y2: 26,
    x1: -25.5,
    y1: -25.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#68b2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5da7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#529bf7"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i3",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    x2: 19.75,
    y2: 21,
    x1: -19,
    y1: -18.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#68b2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5da7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#529bf7"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    x2: 27,
    y2: 26,
    x1: -24,
    y1: -16
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#275dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#3c7ce0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#529bf7"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i5",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    x2: 32,
    y2: 22,
    x1: -19,
    y1: -17
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#68b2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5da7f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#529bf7"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i6",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad",
    x2: -24.5,
    y2: 19.5,
    x1: 19,
    y1: -4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#275dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#3c7ce0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#529bf7"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    type: "matrix"
  }))), /*#__PURE__*/React.createElement("mask", {
    height: 20000,
    width: 20000,
    y: -10000,
    x: -10000,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    "mask-type": "alpha",
    id: "i8"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-600,-600)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i7)",
    transform: "matrix(0.991,0,0,0.956,599.897,615.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,-63.75,353.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1fff",
    d: "M0,-43C-29.426,-43,-56.057,-38.187,-75.298,-30.411C-94.427,-22.68,-106.25,-12.021,-106.25,-0.25C-106.25,7.747,-105.611,15.356,-96.113,21.757C-77.569,34.255,-38.805,42.5,0,42.5C39.656,42.5,76.647,34.133,94.902,21.178C103.659,14.963,107.011,4.654,107.011,-3C107.011,-7.915,104.917,-12.517,101.07,-16.724C86.44,-32.724,46.464,-43,0,-43Z"
  })))))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    type: "matrix"
  }))), /*#__PURE__*/React.createElement("mask", {
    height: 20000,
    width: 20000,
    y: -10000,
    x: -10000,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    "mask-type": "alpha",
    id: "i11"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-600,-600)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i10)",
    transform: "matrix(1.006,0,0,1,600.506,600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,-63,348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1fff",
    d: "M0,-36C-57.161,-36,-103.5,-19.882,-103.5,0C-103.5,19.882,-57.161,36,0,36C57.161,36,103.5,19.882,103.5,0C103.5,-19.882,57.161,-36,0,-36Z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,266.426,678.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.533,242.741",
    strokeDasharray: "5.678 5.678",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#1a1a1a"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    fill: "freeze",
    dur: "6s",
    begin: "0s",
    calcMode: "discrete",
    keyTimes: "0; 0.002778; 0.008333; 0.013889; 0.019444; 0.025; 0.030556; 0.036111; 0.041667; 0.047222; 0.052778; 0.058333; 0.063889; 0.069444; 0.075; 0.080556; 0.086111; 0.091667; 0.097222; 0.102778; 0.108333; 0.113889; 0.119444; 0.125; 0.130556; 0.136111; 0.141667; 0.147222; 0.152778; 0.158333; 0.163889; 0.169444; 0.175; 0.180556; 0.186111; 0.191667; 0.197222; 0.202778; 0.208333; 0.213889; 0.219444; 0.225; 0.230556; 0.236111; 0.241667; 0.247222; 0.252778; 0.258333; 0.263889; 0.269444; 0.275; 0.280556; 0.286111; 0.291667; 0.297222; 0.302778; 0.308333; 0.313889; 0.319444; 0.325; 0.330556; 0.336111; 0.341667; 0.347222; 0.352778; 0.358333; 0.363889; 0.369444; 0.375; 0.380556; 0.386111; 0.391667; 0.397222; 0.402778; 0.408333; 0.413889; 0.419444; 0.425; 0.430556; 0.436111; 0.441667; 0.447222; 0.452778; 0.458333; 0.463889; 0.469444; 0.475; 0.480556; 0.486111; 0.491667; 0.497222; 0.502778; 0.508333; 0.513889; 0.519444; 0.525; 0.530556; 0.536111; 0.541667; 0.547222; 0.552778; 0.558333; 0.563889; 0.569444; 0.575; 0.580556; 0.586111; 0.591667; 0.597222; 0.602778; 0.608333; 0.613889; 0.619444; 0.625; 0.630556; 0.636111; 0.641667; 0.647222; 0.652778; 0.658333; 0.663889; 0.669444; 0.675; 0.680556; 0.686111; 0.691667; 0.697222; 0.702778; 0.708333; 0.713889; 0.719444; 0.725; 0.730556; 0.736111; 0.741667; 0.747222; 0.752778; 0.758333; 0.763889; 0.769444; 0.775; 0.780556; 0.786111; 0.791667; 0.797222; 0.802778; 0.808333; 0.813889; 0.819444; 0.825; 0.830556; 0.836111; 0.841667; 0.847222; 0.852778; 0.858333; 0.863889; 0.869444; 0.875; 0.880556; 0.886111; 0.891667; 0.897222; 0.902778; 0.908333; 0.913889; 0.919444; 0.925; 0.930556; 0.936111; 0.941667; 0.947222; 0.952778; 0.958333; 0.963889; 0.969444; 0.975; 0.980556; 0.986111; 0.991667; 1",
    values: "M200.533,242.741; M200.533,242.741C200.214,242.708,199.896,242.674,199.577,242.641; M200.533,242.741C199.278,242.611,198.028,242.477,196.783,242.341; M200.533,242.741C197.742,242.451,194.976,242.147,192.236,241.828; M200.533,242.741C195.616,242.231,190.778,241.675,186.02,241.073; M200.533,242.741C192.903,241.95,185.466,241.047,178.22,240.037; M200.533,242.741C189.575,241.605,179.016,240.238,168.846,238.654; M200.533,242.741C185.652,241.198,171.507,239.231,158.074,236.87; M200.533,242.741C181.121,240.728,162.959,237.993,146,234.604; M200.533,242.741C175.962,240.193,153.394,236.488,132.731,231.764; M200.533,242.741C170.116,239.587,142.771,234.66,118.306,228.222; M200.533,242.741C163.581,238.91,131.162,232.461,102.934,223.865; M200.533,242.741C156.28,238.153,118.529,229.811,86.691,218.523; M200.533,242.741C148.194,237.315,104.951,226.637,69.829,212.046; M200.533,242.741C139.267,236.389,90.465,222.841,52.561,204.245; M200.533,242.741C129.399,235.366,75.067,218.29,35.087,194.874; M200.533,242.741C118.522,234.239,58.843,212.841,17.745,183.7; M200.533,242.741C106.629,233.006,42.005,206.364,1.027,170.55; M200.533,242.741C93.66,231.661,24.713,198.683,-14.613,155.206; M200.533,242.741C79.703,230.215,7.352,189.696,-28.523,137.662; M200.533,242.741C64.779,228.667,-9.782,179.259,-40.17,117.885; M200.533,242.741C49.202,227.053,-26.088,167.455,-48.911,96.319; M200.533,242.741C33.181,225.392,-41.176,154.344,-54.424,73.377; M200.533,242.741C16.989,223.713,-54.694,140.094,-56.582,49.638; M200.533,242.741C0.904,222.046,-66.399,124.942,-55.499,25.738; M200.533,242.741C-15.02,220.395,-76.294,108.964,-51.425,1.995; M200.533,242.741C-30.629,218.777,-84.359,92.359,-44.693,-21.137; M200.533,242.741C-45.82,217.202,-90.655,75.301,-35.686,-43.313; M200.533,242.741C-60.67,215.662,-95.328,57.77,-24.68,-64.478; M200.533,242.741C-75.12,214.164,-98.47,39.9,-12.008,-84.411; M200.533,242.741C-89.163,212.709,-100.194,21.767,2.042,-102.996; M200.533,242.741C-102.846,211.29,-100.614,3.371,17.269,-120.207; M200.533,242.741C-116.063,209.92,-99.84,-15.08,33.318,-135.856; M200.533,242.741C-128.901,208.589,-97.977,-33.644,50.079,-150.015; M200.533,242.741C-141.288,207.305,-95.142,-52.155,67.265,-162.591; M200.533,242.741C-153.25,206.065,-91.437,-70.589,84.731,-173.621; M200.533,242.741C-164.705,204.877,-86.998,-88.755,102.192,-183.069; M200.533,242.741C-175.615,203.746,-81.961,-106.525,119.435,-190.975; M200.533,242.741C-185.987,202.671,-76.439,-123.843,136.333,-197.435; M200.533,242.741C-195.771,201.657,-70.575,-140.556,152.683,-202.529; M200.533,242.741C-204.877,200.713,-64.546,-156.442,168.223,-206.35; M200.533,242.741C-213.302,199.839,-58.478,-171.422,182.851,-209.058; M200.533,242.741C-220.96,199.046,-52.553,-185.275,196.333,-210.8; M200.533,242.741C-227.851,198.331,-46.889,-197.931,208.602,-211.761; M200.533,242.741C-233.937,197.7,-41.624,-209.264,219.536,-212.117; M200.533,242.741C-239.185,197.156,-36.887,-219.146,229.028,-212.042; M200.533,242.741C-243.518,196.707,-32.837,-227.387,236.907,-211.708; M200.533,242.741C-246.948,196.351,-29.544,-233.961,243.168,-211.266; M200.533,242.741C-249.443,196.093,-27.099,-238.772,247.735,-210.843; M200.533,242.741C-250.969,195.935,-25.583,-241.726,250.533,-210.543; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M199.577,242.641C-251.172,195.262,-24.865,-242.716,251.491,-210.433; M196.624,242.324C-250.18,193.344,-24.26,-242.646,251.491,-210.433; M191.916,241.791C-248.583,190.271,-23.286,-242.532,251.491,-210.433; M185.46,241.002C-246.364,186.022,-21.933,-242.374,251.491,-210.433; M177.263,239.903C-243.494,180.566,-20.186,-242.17,251.491,-210.433; M167.576,238.455C-240.023,174.027,-18.076,-241.923,251.491,-210.433; M156.415,236.575C-235.909,166.363,-15.58,-241.632,251.491,-210.433; M143.954,234.191C-231.158,157.627,-12.705,-241.296,251.491,-210.433; M130.149,231.166C-225.683,147.71,-9.398,-240.91,251.491,-210.433; M115.28,227.414C-219.509,136.716,-5.68,-240.475,251.491,-210.433; M99.33,222.749C-212.52,124.517,-1.484,-239.985,251.491,-210.433; M82.612,217.048C-204.724,111.211,3.18,-239.44,251.491,-210.433; M65.32,210.132C-196.057,96.787,8.345,-238.837,251.491,-210.433; M47.541,201.72C-186.362,81.107,14.099,-238.165,251.491,-210.433; M29.722,191.641C-175.628,64.3,20.439,-237.424,251.491,-210.433; M12.241,179.667C-163.779,46.414,27.402,-236.611,251.491,-210.433; M-4.56,165.473C-150.65,27.397,35.074,-235.715,251.491,-210.433; M-19.964,149.006C-136.315,7.58,43.4,-234.742,251.491,-210.433; M-33.338,130.256C-120.827,-12.742,52.336,-233.698,251.491,-210.433; M-44.114,109.271C-104.229,-33.288,61.847,-232.587,251.491,-210.433; M-51.671,86.667C-86.936,-53.369,71.684,-231.438,251.491,-210.433; M-55.806,62.786C-69.075,-72.718,81.77,-230.26,251.491,-210.433; M-56.461,38.392C-51.047,-90.848,91.874,-229.079,251.491,-210.433; M-53.856,14.044C-33.079,-107.548,101.871,-227.911,251.491,-210.433; M-48.303,-9.893C-15.264,-122.784,111.712,-226.762,251.491,-210.433; M-40.187,-33.004C2.248,-136.507,121.317,-225.64,251.491,-210.433; M-29.844,-55.123C19.466,-148.811,130.698,-224.544,251.491,-210.433; M-17.6,-76.065C36.366,-159.765,139.844,-223.476,251.491,-210.433; M-3.852,-95.567C52.825,-169.384,148.696,-222.442,251.491,-210.433; M11.259,-113.722C68.998,-177.848,157.34,-221.432,251.491,-210.433; M27.319,-130.269C84.707,-185.147,165.687,-220.457,251.491,-210.433; M44.196,-145.273C100.047,-191.412,173.791,-219.51,251.491,-210.433; M61.657,-158.685C114.988,-196.71,181.641,-218.593,251.491,-210.433; M79.35,-170.398C129.391,-201.078,189.168,-217.714,251.491,-210.433; M97.178,-180.509C143.318,-204.621,196.411,-216.868,251.491,-210.433; M114.93,-189.04C156.722,-207.409,203.347,-216.057,251.491,-210.433; M132.24,-195.984C169.431,-209.497,209.894,-215.292,251.491,-210.433; M149.049,-201.493C181.495,-210.986,216.083,-214.57,251.491,-210.433; M165.16,-205.674C192.849,-211.953,221.883,-213.892,251.491,-210.433; M180.23,-208.635C203.314,-212.476,227.209,-213.27,251.491,-210.433; M194.252,-210.578C212.941,-212.648,232.093,-212.699,251.491,-210.433; M206.915,-211.664C221.558,-212.554,236.451,-212.19,251.491,-210.433; M218.25,-212.1C229.221,-212.275,240.315,-211.739,251.491,-210.433; M228.064,-212.066C235.823,-211.888,243.637,-211.351,251.491,-210.433; M236.345,-211.74C241.374,-211.459,246.424,-211.025,251.491,-210.433; M242.846,-211.292C245.722,-211.056,248.604,-210.77,251.491,-210.433; M247.574,-210.86C248.878,-210.728,250.184,-210.586,251.491,-210.433; M250.533,-210.543C250.852,-210.507,251.172,-210.471,251.491,-210.433; M251.491,-210.433; M251.491,-210.433",
    attributeName: "d"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,621.029,973.18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i1)",
    fillRule: "evenodd",
    d: "M-8.431,-53.59C-248.795,-53.115,-442.266,-32.432,-442.266,-6.986C-442.266,3.189,-411.33,12.602,-358.84,20.266C-360.221,22.308,-360.934,24.393,-360.934,26.512C-360.934,51.204,-264.087,71.219,-144.62,71.219C-46.406,71.219,36.518,57.692,62.914,39.16C277.373,35.94,442.267,16.507,442.267,-6.986C442.267,-15.785,419.129,-24.014,378.922,-31.036C367.95,-53.602,275.781,-71.219,163.703,-71.219C93.487,-71.219,31.088,-64.304,-8.431,-53.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,626.872,965.899)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6e696e",
    d: "M12.94,-7.318C12.94,1.927,2.582,10.343,-14.401,16.665C-14.401,16.665,-13.527,6.45,-13.527,6.45C-11.804,5.816,-10.154,5.161,-8.575,4.493C5.121,-1.339,13.538,-8.667,14.208,-16.665C14.222,-16.593,14.238,-16.516,14.253,-16.445C14.401,-15.668,12.94,-8.105,12.94,-7.318Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,522.421,971.148)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6e696e",
    d: "M90.925,1.201C90.925,1.201,90.051,11.417,90.051,11.417C71.01,18.505,43.645,22.95,13.234,22.95C-44.293,22.95,-90.925,7.047,-90.925,-12.567C-90.925,-13.501,-89.816,-22.035,-89.612,-22.95C-89.612,-3.332,-42.975,12.571,14.547,12.571C44.728,12.571,71.905,8.197,90.925,1.201Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,533.791,948.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb485c",
    d: "M95.54,-11.567C95.54,-11.567,3.176,-0.003,3.176,-0.003C3.176,-0.003,79.555,24.149,79.555,24.149C60.535,31.145,33.358,35.519,3.176,35.519C-54.345,35.519,-100.982,19.616,-100.982,-0.003C-100.982,-19.621,-54.345,-35.519,3.176,-35.519C48.085,-35.519,86.356,-25.83,100.982,-12.247C100.982,-12.247,95.54,-11.567,95.54,-11.567Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,589.047,954.151)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb485c",
    d: "M52.079,-5.953C52.079,-5.605,52.063,-5.258,52.033,-4.916C51.363,3.082,42.946,10.41,29.251,16.241C27.672,16.91,26.021,17.565,24.299,18.198C24.299,18.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,40.284,-17.517,40.284,-17.517C40.284,-17.517,45.726,-18.197,45.726,-18.197C49.835,-14.38,52.079,-10.256,52.079,-5.953Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i8)",
    transform: "matrix(1,0,0,1,600,600)",
    id: "i17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.703,347.151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 90; 164; 266; 360; 360",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "translate(52.5,7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M44.049,25.948C44.049,25.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,45.771,25.315,44.049,25.948Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M44.049,25.948C44.049,25.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,45.771,25.315,44.049,25.948Z; M10.049,65.948C10.049,65.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,20.534,-33.017,20.534,-33.017C20.534,-33.017,11.771,65.315,10.049,65.948Z; M54.949,51.413C54.949,51.413,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,96.193,-8.646,96.193,-8.646C96.193,-8.646,56.671,50.78,54.949,51.413Z; M23.86,58.762C23.86,58.762,-52.08,-5.954,-52.08,-5.954C-52.08,-5.954,33.038,-36.736,33.038,-36.736C33.038,-36.736,25.582,58.129,23.86,58.762Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))))))), /*#__PURE__*/React.createElement("g", {
    display: "none",
    transform: "matrix(0.991,0,0,0.956,599.897,615.619)",
    id: "i21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,-63.75,353.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1fff",
    d: "M0,-43C-29.426,-43,-56.057,-38.187,-75.298,-30.411C-94.427,-22.68,-106.25,-12.021,-106.25,-0.25C-106.25,7.747,-105.611,15.356,-96.113,21.757C-77.569,34.255,-38.805,42.5,0,42.5C39.656,42.5,76.647,34.133,94.902,21.178C103.659,14.963,107.011,4.654,107.011,-3C107.011,-7.915,104.917,-12.517,101.07,-16.724C86.44,-32.724,46.464,-43,0,-43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i11)",
    transform: "matrix(1,0,0,1,600,600)",
    id: "i17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.703,347.151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 90; 164; 266; 360; 360",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "translate(52.5,7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M39.549,24.198C39.549,24.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,41.271,23.565,39.549,24.198Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M39.549,24.198C39.549,24.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,41.271,23.565,39.549,24.198Z; M10.049,65.948C10.049,65.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,20.534,-33.017,20.534,-33.017C20.534,-33.017,11.771,65.315,10.049,65.948Z; M54.949,51.413C54.949,51.413,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,96.193,-8.646,96.193,-8.646C96.193,-8.646,56.671,50.78,54.949,51.413Z; M23.86,58.762C23.86,58.762,-52.08,-5.954,-52.08,-5.954C-52.08,-5.954,33.038,-36.736,33.038,-36.736C33.038,-36.736,25.582,58.129,23.86,58.762Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.703,347.151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 90; 164; 266; 360; 360",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "translate(52.5,7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M39.549,24.198C39.549,24.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,41.271,23.565,39.549,24.198Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M39.549,24.198C39.549,24.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,41.271,23.565,39.549,24.198Z; M10.049,65.948C10.049,65.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,20.534,-33.017,20.534,-33.017C20.534,-33.017,11.771,65.315,10.049,65.948Z; M54.949,51.413C54.949,51.413,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,96.193,-8.646,96.193,-8.646C96.193,-8.646,56.671,50.78,54.949,51.413Z; M23.86,58.762C23.86,58.762,-52.08,-5.954,-52.08,-5.954C-52.08,-5.954,33.038,-36.736,33.038,-36.736C33.038,-36.736,25.582,58.129,23.86,58.762Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))))))), /*#__PURE__*/React.createElement("g", {
    display: "none",
    transform: "matrix(1.006,0,0,1,600.506,600)",
    id: "i22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,-63,348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1fff",
    d: "M0,-36C-57.161,-36,-103.5,-19.882,-103.5,0C-103.5,19.882,-57.161,36,0,36C57.161,36,103.5,19.882,103.5,0C103.5,-19.882,57.161,-36,0,-36Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.73,955.822)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1.05 1.05; 1 1; 1 1; 1.05 1.05; 1 1; 1 1",
    keyTimes: "0; 0.083333; 0.166667; 0.5; 0.583333; 0.666667; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-293.73,-955.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i24",
    transform: "matrix(1,0,0,1,282.812,890.213)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde70",
    d: "M64.608,27.462C60.4,70.065,-4.06,78.474,-34.604,45.118C-65.155,11.769,-2.935,-51.289,-2.935,-51.289C-2.935,-51.289,-11.068,-71.19,-11.068,-71.19C-11.068,-71.19,-5.324,-75.622,-1.116,-76.603C0.176,-76.909,1.318,-76.887,2.109,-76.315C5.468,-73.874,10.795,-72.869,21.445,-75.675C32.094,-78.474,35.177,-71.19,35.177,-71.19C35.177,-71.19,23.125,-50.451,23.125,-50.451C23.125,-50.451,57.699,-23.723,63.921,11.273C64.856,16.507,65.156,21.921,64.608,27.462Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,282.812,891.149)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M64.608,26.527C60.4,69.13,-4.06,77.539,-34.604,44.183C-65.155,10.834,-2.935,-52.224,-2.935,-52.224C-2.935,-52.224,-11.068,-72.125,-11.068,-72.125C-11.068,-72.125,-5.324,-76.558,-1.116,-77.539C1.874,-67.907,6.813,-50.689,4.47,-48.906C1.197,-46.407,-43.789,1.876,-15.258,27.929C8.966,50.059,49.815,45.008,63.921,10.338C64.856,15.572,65.156,20.986,64.608,26.527Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,292.53,850.541)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M1.198,-9.656C1.198,-9.656,3.994,5.479,-1.191,10.383C-3.994,11.224,-3.994,9.262,-3.994,9.262C-3.994,9.262,0.56,-1.668,-0.561,-9.656C0.016,-11.224,1.198,-9.656,1.198,-9.656Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,321.795,853.217)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M-19.945,-12.122C-19.945,-12.122,-2.382,12.519,15.835,8.689C19.946,3.924,15.18,3.082,15.18,3.082C15.18,3.082,-11.444,-4.719,-14.993,-12.122C-17.329,-12.519,-19.945,-12.122,-19.945,-12.122Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,292.367,840.792)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M-17.423,-3.643C-17.423,-3.643,7.147,0.747,15.648,-2.336C20.786,-1.682,17.516,0.373,17.516,0.373C17.516,0.373,-11.631,3.643,-16.489,-0.935C-20.786,-3.364,-17.423,-3.643,-17.423,-3.643Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,299.307,904.856)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-2.69,3.927C-4.504,3.308,-6.153,2.68,-7.638,2.04C-9.122,1.402,-10.401,0.628,-11.472,-0.279C-12.544,-1.185,-13.379,-2.267,-13.977,-3.525C-14.575,-4.783,-14.874,-6.318,-14.874,-8.134C-14.874,-10.936,-14.007,-13.298,-12.276,-15.215C-10.544,-17.132,-8.07,-18.44,-4.854,-19.141C-4.854,-19.141,-4.854,-24.151,-4.854,-24.151C-4.483,-24.233,-3.907,-24.337,-3.123,-24.46C-2.34,-24.584,-1.537,-24.645,-0.711,-24.645C0.897,-24.645,2.154,-24.368,3.061,-23.811C3.968,-23.255,4.422,-22.068,4.422,-20.255C4.422,-20.255,4.422,-19.451,4.422,-19.451C6.978,-19.12,9.03,-18.462,10.576,-17.471C12.122,-16.482,12.895,-15.122,12.895,-13.39C12.895,-12.317,12.647,-11.4,12.153,-10.637C11.658,-9.875,11.06,-9.225,10.359,-8.689C9.452,-9.266,8.236,-9.772,6.71,-10.205C5.185,-10.637,3.515,-10.854,1.701,-10.854C-0.155,-10.854,-1.515,-10.596,-2.38,-10.081C-3.247,-9.565,-3.679,-8.916,-3.679,-8.134C-3.679,-7.514,-3.412,-7.01,-2.876,-6.618C-2.34,-6.225,-1.537,-5.865,-0.463,-5.536C-0.463,-5.536,2.814,-4.484,2.814,-4.484C6.69,-3.247,9.668,-1.67,11.751,0.247C13.832,2.164,14.874,4.773,14.874,8.071C14.874,10.875,13.987,13.256,12.215,15.213C10.441,17.172,7.844,18.502,4.422,19.202C4.422,19.202,4.422,24.15,4.422,24.15C4.051,24.233,3.474,24.335,2.69,24.459C1.907,24.583,1.103,24.645,0.279,24.645C-1.33,24.645,-2.587,24.366,-3.494,23.81C-4.401,23.253,-4.854,22.068,-4.854,20.254C-4.854,20.254,-4.854,19.636,-4.854,19.636C-6.339,19.47,-7.69,19.202,-8.905,18.831C-10.123,18.46,-11.173,17.987,-12.06,17.409C-12.947,16.832,-13.636,16.152,-14.131,15.368C-14.626,14.585,-14.874,13.698,-14.874,12.709C-14.874,11.514,-14.524,10.493,-13.822,9.648C-13.122,8.803,-12.359,8.154,-11.534,7.699C-10.38,8.607,-8.967,9.391,-7.298,10.049C-5.628,10.709,-3.803,11.039,-1.824,11.039C0.196,11.039,1.618,10.73,2.443,10.112C3.268,9.493,3.68,8.772,3.68,7.947C3.68,7.122,3.35,6.493,2.69,6.061C2.03,5.627,1.103,5.205,-0.092,4.792C-0.092,4.792,-2.69,3.927,-2.69,3.927Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i26",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i27",
    transform: "matrix(1,0,0,1,906.631,890.966)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b080b0",
    d: "M-38.469,-21.874C-38.469,-21.874,-36.198,21.874,-36.198,21.874C-19.171,21.723,-2.081,11.411,12.907,3.501C20.165,-0.293,28.13,-3.283,36.329,-5.151C36.329,-5.151,38.469,-18.205,38.469,-18.205C38.469,-18.205,-38.469,-21.874,-38.469,-21.874Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i28",
    transform: "matrix(1,0,0,1,906.697,911.225)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#572658",
    d: "M-36.263,1.615C-36.263,1.615,-35.205,22,-35.205,22C-13.39,25.41,7.935,24.82,28.777,20.262C28.777,20.262,36.263,-25.41,36.263,-25.41C28.064,-23.542,20.099,-20.552,12.841,-16.758C-2.147,-8.848,-19.237,1.464,-36.263,1.615Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i29",
    transform: "matrix(1,0,0,1,913.088,870.272)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M35.179,0C35.179,2.061,19.428,3.731,-0.001,3.731C-19.429,3.731,-35.179,2.061,-35.179,0C-35.179,-2.061,-19.429,-3.73,-0.001,-3.73C19.428,-3.73,35.179,-2.061,35.179,0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(910.464,853.192)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 13; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i30",
    transform: "translate(-910.464,-853.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i31",
    transform: "matrix(1,0,0,1,972.043,787.879)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#339e7e",
    d: "M-61.71,64.69C-61.71,64.69,22.598,113.013,65.249,53.291C107.899,-6.431,89.421,-61.98,42.816,-87.497C-3.788,-113.013,-67.88,-93.155,-87.89,-62.14C-107.899,-31.126,-53.967,52.919,-61.71,64.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i32",
    transform: "matrix(1,0,0,1,943.945,803.529)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M63.113,-68.152C63.113,-68.152,19.752,28.824,-63.113,68.151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i33",
    transform: "matrix(1,0,0,1,1004.76,735.271)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M30.667,21.334C30.667,21.334,11.14,8.375,-6.098,16.459C-10.593,-2.879,-30.668,-21.334,-30.668,-21.334"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i34",
    transform: "matrix(1,0,0,1,988.026,751.906)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M44.831,36.065C44.831,36.065,15.446,14.462,1.211,17.051C-2.505,3.983,-17.611,-24.732,-44.831,-36.065"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i35",
    transform: "matrix(1,0,0,1,976.897,771.936)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M67.363,44.995C67.363,44.995,23.98,12.806,0.965,15.131C0.393,3.136,-26.168,-36.069,-67.362,-44.994"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i36",
    transform: "matrix(1,0,0,1,962.517,786.94)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M53.562,37.602C53.562,37.602,28.902,13.358,2.654,14.742C0.692,0.217,-27.627,-32.813,-53.562,-37.602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i37",
    transform: "matrix(1,0,0,1,954.725,807.986)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M45.514,34.818C45.514,34.818,18.686,6.174,-2.855,9.957C-3.035,-5.718,-21.79,-25.399,-45.514,-34.818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i38",
    transform: "matrix(1,0,0,1,947.317,823.887)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M41.636,31.233C41.636,31.233,21.343,10.34,-10.032,8.239C-11.466,-3.358,-26.53,-29.407,-41.635,-31.233"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(913.391,864.883)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 21; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i39",
    transform: "translate(-913.391,-864.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i40",
    transform: "matrix(1,0,0,1,988.684,899.123)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00593b",
    d: "M-46.424,-29.612C-46.424,-29.612,-4.115,-67.67,18.718,-51.038C41.551,-34.406,69.292,-3.307,43.568,29.286C17.845,61.881,-20.994,67.67,-45.144,34.727C-69.292,1.784,-39.057,-9.263,-46.424,-29.612Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i41",
    transform: "matrix(1,0,0,1,962.344,897.102)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M54.13,30.315C54.13,30.315,23.572,-24.086,-20.085,-27.591C-54.022,-30.315,-54.131,-27.35,-54.131,-27.35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i42",
    transform: "matrix(1,0,0,1,965.607,878.161)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M21.235,-24.947C21.235,-24.947,3.439,-7.544,-9.499,-6.387C4.582,3.292,-13.673,20.948,-21.235,24.947"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i43",
    transform: "matrix(1,0,0,1,975.649,887.918)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M31.992,-29.31C31.992,-29.31,18.345,-12.01,-5.603,-10.582C1.255,-0.54,-7.771,21.987,-31.992,29.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i44",
    transform: "matrix(1,0,0,1,989.84,901.915)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M31.105,-25.807C31.105,-25.807,13.477,-8.903,-5.857,-13.513C-3.86,-5.204,-11.132,23.392,-31.106,25.807"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i45",
    transform: "matrix(1,0,0,1,997.346,920.47)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M32.323,-25.088C32.323,-25.088,10.052,-16.063,-0.158,-19.316C-1.94,-7.415,-2.948,17.072,-32.324,25.087"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i46",
    transform: "matrix(1,0,0,1,1009.258,925.816)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M13.417,-15.818C13.417,-15.818,3.754,-11.287,-2.188,-12.935C-0.943,-1.307,-6.053,12.643,-13.417,15.818"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(911.214,863.699)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 17; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i47",
    transform: "translate(-911.214,-863.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i48",
    transform: "matrix(1,0,0,1,848.717,850.381)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#127755",
    d: "M57.295,6.552C57.295,6.552,53.252,-52.681,24.071,-56.81C-5.109,-60.939,-48.475,-57.799,-52.885,-14.703C-57.295,28.393,-32.412,60.939,9.604,53.807C51.618,46.676,36.997,16.441,57.295,6.552Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i24",
    transform: "matrix(1,0,0,1,863.452,849.269)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-55.082,-2.876C-55.082,-2.876,8.324,-22.601,42.56,7.664C55.082,18.734,47.2,22.601,47.2,22.601"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,885.209,846.452)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-0.748,-34.107C-0.748,-34.107,-0.061,-8.148,8.789,2.117C-8.788,-0.862,-7.94,25.621,-5.182,34.107"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,868.501,846.465)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-3.534,-45.189C-3.534,-45.189,-5.881,-22.32,11.017,-3.857C-1.412,-1.317,-11.016,22.112,1.804,45.189"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,849.614,846.641)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-7.325,-41.921C-7.325,-41.921,-6.4,-16.457,11.428,-5.866C3.898,-1.094,-11.428,25.604,1.779,41.921"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,829.719,855.085)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-7.963,-42.267C-7.963,-42.267,2.161,-19.331,12.171,-14.352C4.86,-4.145,-12.171,14.926,4.008,42.267"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,818.129,850.437)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-1.75,-21.592C-1.75,-21.592,2.194,-11.181,7.843,-8.099C-1.536,-0.294,-7.843,13.863,-4.633,21.592"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "i49"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,600)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0.509; 1; 1",
    path: "M0 0 C0 3.333 0 23.333 0 20 C0 20 0 0 0 0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-600,-600)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.687,747.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -60; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i2)",
    fillRule: "evenodd",
    d: "M24.22,26.07C24.22,26.07,0,15.881,0,15.881C0,15.881,-24.22,5.69,-24.22,5.69C-24.22,5.69,-3.286,-10.19,-3.286,-10.19C-3.286,-10.19,17.649,-26.07,17.649,-26.07C17.649,-26.07,20.935,0,20.935,0C20.935,0,24.22,26.07,24.22,26.07Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(833.315,637.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 40; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i3)",
    d: "M18.351,4.807C18.351,4.807,-0.001,12.198,-0.001,12.198C-0.001,12.198,-18.351,19.588,-18.351,19.588C-18.351,19.588,-15.576,0,-15.576,0C-15.576,0,-12.799,-19.587,-12.799,-19.587C-12.799,-19.587,2.776,-7.391,2.776,-7.391C2.776,-7.391,18.351,4.807,18.351,4.807Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(822.847,754.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 60; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i4)",
    fillRule: "evenodd",
    d: "M10.173,26.552C10.173,26.552,-8.548,5.873,-8.548,5.873C-8.548,5.873,-27.269,-14.807,-27.269,-14.807C-27.269,-14.807,0.001,-20.68,0.001,-20.68C0.001,-20.68,27.27,-26.553,27.27,-26.553C27.27,-26.553,18.721,0,18.721,0C18.721,0,10.173,26.552,10.173,26.552Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.544,911.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -40; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i5)",
    d: "M18.84,17.847C18.84,17.847,-0.001,14.784,-0.001,14.784C-0.001,14.784,-18.84,11.722,-18.84,11.722C-18.84,11.722,-6.768,-3.062,-6.768,-3.062C-6.768,-3.062,5.304,-17.847,5.304,-17.847C5.304,-17.847,12.072,0,12.072,0C12.072,0,18.84,17.847,18.84,17.847Z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "i50"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(886.251,547.726)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 75; 25; -75; 0; 0",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.592 0 0.414 1; 0.592 0 0.414 1; 0.592 0 0.414 1; 0.592 0 0.414 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-886.251,-547.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,878.087,547.726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M8.164,0C8.164,0,34.57,42.833,34.57,42.833C26.893,47.577,17.85,50.313,8.164,50.313C-19.622,50.313,-42.149,27.792,-42.149,0C-42.149,-27.786,-19.622,-50.313,8.164,-50.313C21.267,-50.313,33.196,-45.304,42.149,-37.102C42.149,-37.102,8.164,0,8.164,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,911.408,562.594)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb485c",
    d: "M25.157,-14.869C25.157,-3.031,21.07,7.843,14.236,16.432C14.236,16.432,-25.156,-14.869,-25.156,-14.869C-25.156,-14.869,25.128,-16.432,25.128,-16.432C25.151,-15.913,25.157,-15.394,25.157,-14.869Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,911.393,529.175)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i6)",
    fillRule: "evenodd",
    d: "M-25.142,18.551C-25.142,18.551,25.143,16.986,25.143,16.986C24.715,2.932,18.522,-9.68,8.844,-18.551C8.844,-18.551,-25.142,18.551,-25.142,18.551Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,905.947,569.142)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M19.696,9.884C16.078,14.438,11.679,18.346,6.71,21.417C6.71,21.417,-19.697,-21.417,-19.697,-21.417C-19.697,-21.417,19.696,9.884,19.696,9.884Z"
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "i51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i52"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,600)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0.248; 0.496; 0.752; 1; 1",
    path: "M0 0 C1.667 0 10 0 10 0 C10 0 0 0 0 0 C0 0 11.667 0 10 0 C10 0 0 0 0 0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-600,-600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i47",
    transform: "matrix(1,0,0,1,332.938,598.423)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6584c6",
    d: "M53.91,6.412C53.506,5.587,-55.133,35.54,-55.878,35.956C-55.52,35.252,-32.357,-9.843,9.922,-20.764C19.457,-23.234,29.968,-23.956,41.414,-22.039C54.042,-19.927,64.761,-15.281,73.378,-8.979C64.197,-7.379,58.779,-1.756,53.91,6.412Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M53.91,6.412C53.506,5.587,-55.133,35.54,-55.878,35.956C-55.52,35.252,-32.357,-9.843,9.922,-20.764C19.457,-23.234,29.968,-23.956,41.414,-22.039C54.042,-19.927,64.761,-15.281,73.378,-8.979C64.197,-7.379,58.779,-1.756,53.91,6.412Z; M45.16,0.412C44.756,-0.413,-63.883,29.54,-64.628,29.956C-64.27,29.252,-41.107,-15.843,1.172,-26.764C10.707,-29.234,21.218,-29.956,32.664,-28.039C45.292,-25.927,56.011,-21.281,64.628,-14.979C55.447,-13.379,50.029,-7.756,45.16,0.412Z; M45.16,0.412C44.756,-0.413,-63.883,29.54,-64.628,29.956C-64.27,29.252,-41.107,-15.843,1.172,-26.764C10.707,-29.234,26.468,-32.206,37.914,-30.289C50.542,-28.177,57.313,-26.423,67.378,-19.729C58.197,-18.129,50.029,-7.756,45.16,0.412Z; M44.91,9.662C44.506,8.837,-56.883,36.54,-57.628,36.956C-57.27,36.252,-41.357,-6.593,0.922,-17.514C10.457,-19.984,26.218,-20.956,37.664,-19.039C50.292,-16.927,58.563,-18.923,68.628,-12.229C59.447,-10.629,49.779,1.494,44.91,9.662Z; M53.91,6.412C53.506,5.587,-55.133,35.54,-55.878,35.956C-55.52,35.252,-32.357,-9.843,9.922,-20.764C19.457,-23.234,29.968,-23.956,41.414,-22.039C54.042,-19.927,64.761,-15.281,73.378,-8.979C64.197,-7.379,58.779,-1.756,53.91,6.412Z; M53.91,6.412C53.506,5.587,-55.133,35.54,-55.878,35.956C-55.52,35.252,-32.357,-9.843,9.922,-20.764C19.457,-23.234,29.968,-23.956,41.414,-22.039C54.042,-19.927,64.761,-15.281,73.378,-8.979C64.197,-7.379,58.779,-1.756,53.91,6.412Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i27",
    transform: "matrix(1,0,0,1,669.496,843.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M268.526,62.355C253.401,93.466,234.004,116.7,216.754,130.71C156.504,175.7,45.449,166.301,3.875,121.735C-108.162,4.094,-225.062,100.941,-235.493,56.65C-251.495,-11.3,-194.996,-62.8,-215.003,-82.63C-223.943,-91.491,-240.057,-88.847,-246.59,-88.506C-246.59,-88.506,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-102.745,-162.105,-102.745,-162.105C-95.691,-163.507,-81.188,-156.008,-72.339,-144.582C-24.496,-82.8,-143.996,-42.3,-122.838,8.577C-112.217,34.117,-62.188,3.492,18.053,-12.624C131.032,-35.313,125.768,22.515,201.806,65.903C232.75,87.351,242.189,77.167,268.526,62.355Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M268.526,62.355C253.401,93.466,234.004,116.7,216.754,130.71C156.504,175.7,45.449,166.301,3.875,121.735C-108.162,4.094,-225.062,100.941,-235.493,56.65C-251.495,-11.3,-194.996,-62.8,-215.003,-82.63C-223.943,-91.491,-240.057,-88.847,-246.59,-88.506C-246.59,-88.506,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-102.745,-162.105,-102.745,-162.105C-95.691,-163.507,-81.188,-156.008,-72.339,-144.582C-24.496,-82.8,-143.996,-42.3,-122.838,8.577C-112.217,34.117,-62.188,3.492,18.053,-12.624C131.032,-35.313,125.768,22.515,201.806,65.903C232.75,87.351,242.189,77.167,268.526,62.355Z; M268.526,81.355C253.401,112.466,239.257,129.924,219.754,139.71C129.082,175.507,26.449,154.301,-15.125,109.735C-72.496,38.7,-192.495,72.2,-235.493,56.65C-291.35,36.45,-153.059,-37.01,-215.003,-82.63C-225.139,-90.093,-233.057,-92.847,-239.59,-92.506C-239.59,-92.506,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-125.605,-155.254,-125.605,-155.254C-125.605,-155.254,-115.245,-160.605,-115.245,-160.605C-85.996,-172.8,-69.868,-160.475,-63.34,-147.582C-26.996,-75.8,-127.496,-34.3,-98.838,0.077C-85.723,15.809,-63.188,-7.508,17.053,-23.624C130.032,-46.313,84.769,7.515,160.807,50.903C191.751,72.351,242.189,96.167,268.526,81.355Z; M278.526,62.355C263.401,93.466,245.257,118.924,225.754,128.71C173.504,165.7,28.449,157.301,-13.125,112.735C-105.496,43.7,-210.188,94.467,-235.493,56.65C-268.525,7.284,-178.246,-39.3,-215.003,-82.63C-219.369,-87.776,-221.12,-86.8,-225.965,-89.006C-225.965,-89.006,-179.616,-116.591,-179.616,-116.591C-179.616,-116.591,-110.105,-158.254,-110.105,-158.254C-110.105,-158.254,-99.745,-163.605,-99.745,-163.605C-92.691,-165.007,-86.609,-165.75,-76.339,-155.582C-19.495,-99.3,-128.917,-24.853,-117.838,5.577C-98.496,58.7,-59.132,23.1,10.053,-20.624C66.504,-56.3,87.768,-7.485,163.806,35.903C194.75,57.351,252.189,77.167,278.526,62.355Z; M278.526,52.355C263.401,83.466,245.257,118.924,225.754,128.71C143.504,191.7,28.449,157.301,-13.125,112.735C-98.496,33.7,-210.188,94.467,-235.493,56.65C-268.525,7.284,-153.059,-37.01,-215.003,-82.63C-225.139,-90.093,-233.057,-92.847,-239.59,-92.506C-239.59,-92.506,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-103.745,-165.105,-103.745,-165.105C-96.691,-166.507,-87.975,-164.153,-76.339,-155.582C-14.39,-109.96,-155.876,-40.796,-122.838,8.577C-107.456,31.566,-71.784,-19.569,10.053,-20.624C62.504,-21.3,87.768,-7.485,163.806,35.903C194.75,57.351,252.189,67.167,278.526,52.355Z; M268.525,62.355C253.4,93.466,234.004,116.7,216.754,130.71C156.504,175.7,45.449,166.301,3.875,121.735C-108.162,4.094,-225.062,100.941,-235.493,56.65C-251.495,-11.3,-194.996,-62.8,-215.003,-82.63C-223.943,-91.491,-245.057,-87.347,-251.59,-87.006C-251.59,-87.006,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-102.745,-162.105,-102.745,-162.105C-95.691,-163.507,-81.188,-156.008,-72.339,-144.582C-24.495,-82.8,-143.996,-42.3,-122.838,8.577C-112.217,34.117,-62.188,3.492,18.053,-12.624C131.032,-35.313,125.768,22.515,201.806,65.903C232.75,87.351,242.188,77.167,268.525,62.355Z; M268.525,62.355C253.4,93.466,234.004,116.7,216.754,130.71C156.504,175.7,45.449,166.301,3.875,121.735C-108.162,4.094,-225.062,100.941,-235.493,56.65C-251.495,-11.3,-194.996,-62.8,-215.003,-82.63C-223.943,-91.491,-245.057,-87.347,-251.59,-87.006C-251.59,-87.006,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-102.745,-162.105,-102.745,-162.105C-95.691,-163.507,-81.188,-156.008,-72.339,-144.582C-24.495,-82.8,-143.996,-42.3,-122.838,8.577C-112.217,34.117,-62.188,3.492,18.053,-12.624C131.032,-35.313,125.768,22.515,201.806,65.903C232.75,87.351,242.188,77.167,268.525,62.355Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i28",
    transform: "matrix(1,0,0,1,537.555,739.273)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc4cc",
    d: "M-74.403,9.266C-74.403,9.266,30.088,-52.255,30.088,-52.255C30.088,-52.255,74.403,-35.019,61.359,-6.172C14.041,23.042,-51.382,52.255,-51.382,52.255C-51.382,52.255,-56.167,15.438,-74.403,9.266Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i29",
    transform: "matrix(1,0,0,1,445.728,647.731)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M82.83,-39.22C20.719,-6.868,4.951,51.549,38.652,72.477C38.652,72.477,-22.322,106.812,-22.322,106.812C-35.228,112.518,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-124.962,69.736,-55.833,33.73C-12.856,11.342,-8.608,-35.387,-42.662,-60.287C-51.28,-66.59,-55.998,-68.737,-68.627,-70.849C-80.072,-72.765,-90.083,-73.044,-99.618,-70.574C-99.618,-70.574,8.246,-141.486,8.246,-141.486C8.246,-141.486,8.494,-141.624,8.494,-141.624C22.347,-149.191,40.602,-151.054,60.037,-147.799C122.598,-137.317,136.687,-67.271,82.83,-39.22Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M82.83,-39.22C20.719,-6.868,4.951,51.549,38.652,72.477C38.652,72.477,-22.322,106.812,-22.322,106.812C-35.228,112.518,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-124.962,69.736,-55.833,33.73C-12.856,11.342,-8.608,-35.387,-42.662,-60.287C-51.28,-66.59,-55.998,-68.737,-68.627,-70.849C-80.072,-72.765,-90.083,-73.044,-99.618,-70.574C-99.618,-70.574,8.246,-141.486,8.246,-141.486C8.246,-141.486,8.494,-141.624,8.494,-141.624C22.347,-149.191,40.602,-151.054,60.037,-147.799C122.598,-137.317,136.687,-67.271,82.83,-39.22Z; M77.83,-25.22C17.446,10.251,26.95,40.05,60.651,60.978C60.651,60.978,-15.822,103.062,-15.822,103.062C-38.228,103.768,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-132.462,66.237,-63.333,30.231C-20.356,7.843,-14.108,-39.386,-48.162,-64.286C-56.78,-70.589,-67.498,-75.236,-80.127,-77.348C-91.572,-79.264,-102.083,-78.543,-111.618,-76.073C-111.618,-76.073,8.246,-141.486,8.246,-141.486C8.246,-141.486,24.994,-150.124,24.994,-150.124C38.847,-157.691,51.771,-155.731,68.036,-146.299C127.242,-111.965,129.772,-55.732,77.83,-25.22Z; M75.33,-28.72C16.187,8.784,2.771,60.268,57.151,70.977C57.151,70.977,-2.322,106.562,-2.322,106.562C-16.728,106.268,-42.418,143.437,-61.875,154.883C-68.166,158.589,-78.728,162.768,-88.195,155.992C-130.191,125.933,-132.462,66.236,-63.333,30.23C-20.356,7.842,-5.108,-39.886,-39.162,-64.786C-47.78,-71.089,-57.998,-77.237,-70.627,-79.349C-82.072,-81.265,-102.083,-78.543,-111.618,-76.073C-111.618,-76.073,15.246,-142.986,15.246,-142.986C15.246,-142.986,15.494,-143.624,15.494,-143.624C29.347,-151.191,48.67,-149.986,67.537,-144.299C135.772,-123.731,114.772,-53.732,75.33,-28.72Z; M75.33,-28.72C13.823,4.765,31.771,67.269,54.651,63.978C54.651,63.978,-15.822,103.062,-15.822,103.062C-38.228,103.768,-43.419,136.937,-62.876,148.383C-69.167,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-132.462,66.236,-63.333,30.23C-20.356,7.842,-1.108,-31.886,-35.162,-56.786C-43.78,-63.089,-51.998,-65.237,-64.627,-67.349C-76.072,-69.265,-103.083,-69.543,-112.618,-67.073C-112.618,-67.073,11.246,-137.986,11.246,-137.986C11.246,-137.986,5.494,-134.624,5.494,-134.624C19.347,-142.191,48.67,-146.986,67.537,-141.299C135.772,-120.731,121.272,-53.732,75.33,-28.72Z; M82.83,-39.22C20.719,-6.868,4.951,51.549,38.652,72.477C38.652,72.477,-22.322,106.812,-22.322,106.812C-35.228,112.518,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-124.962,69.736,-55.833,33.73C-12.856,11.342,-8.608,-35.386,-42.662,-60.286C-51.28,-66.589,-55.998,-68.737,-68.627,-70.849C-80.072,-72.765,-90.083,-73.044,-99.618,-70.574C-99.618,-70.574,8.246,-141.486,8.246,-141.486C8.246,-141.486,8.494,-141.624,8.494,-141.624C22.347,-149.191,40.602,-151.054,60.037,-147.799C122.598,-137.317,136.687,-67.271,82.83,-39.22Z; M82.83,-39.22C20.719,-6.868,4.951,51.549,38.652,72.477C38.652,72.477,-22.322,106.812,-22.322,106.812C-35.228,112.518,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-124.962,69.736,-55.833,33.73C-12.856,11.342,-8.608,-35.386,-42.662,-60.286C-51.28,-66.589,-55.998,-68.737,-68.627,-70.849C-80.072,-72.765,-90.083,-73.044,-99.618,-70.574C-99.618,-70.574,8.246,-141.486,8.246,-141.486C8.246,-141.486,8.494,-141.624,8.494,-141.624C22.347,-149.191,40.602,-151.054,60.037,-147.799C122.598,-137.317,136.687,-67.271,82.83,-39.22Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i31",
    transform: "matrix(1,0,0,1,485.488,582.028)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc4cc",
    d: "M-50.137,64.258C0.061,38.029,68.44,-11.041,68.44,-11.041C68.44,-11.041,72.828,-54.656,36.62,-64.257C-6.446,-43.409,-72.828,-4.492,-72.828,-4.492C-72.828,-4.492,-35.873,22.734,-50.137,64.258Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i32",
    transform: "matrix(1,0,0,1,418.673,773.283)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6584c6",
    d: "M36.57,-12.113C36.57,-12.113,-35.82,22.831,-35.82,22.831C-16.364,11.386,-4.298,-21.658,11.357,-19.739C18.401,-18.876,30.577,-18.908,36.57,-12.113Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M36.57,-12.113C36.57,-12.113,-35.82,22.831,-35.82,22.831C-16.364,11.386,-4.298,-21.658,11.357,-19.739C18.401,-18.876,30.577,-18.908,36.57,-12.113Z; M35.82,-12.613C35.82,-12.613,-35.82,22.831,-35.82,22.831C-16.364,11.386,-8.548,-24.658,11.232,-22.489C17.735,-21.776,25.685,-20.076,35.82,-12.613Z; M39.945,-6.113C39.945,-6.113,-29.57,25.706,-29.57,25.706C-10.114,14.261,4.077,-18.283,25.732,-18.864C32.272,-19.039,33.202,-17.783,39.945,-6.113Z; M35.32,-12.863C35.32,-12.863,-35.695,22.956,-35.695,22.956C-16.239,11.511,-10.423,-22.283,11.482,-22.489C18.024,-22.551,24.952,-20.408,35.32,-12.863Z; M36.57,-12.113C36.57,-12.113,-35.82,22.831,-35.82,22.831C-16.364,11.386,-4.298,-21.658,11.357,-19.739C18.401,-18.876,30.577,-18.908,36.57,-12.113Z; M36.57,-12.113C36.57,-12.113,-35.82,22.831,-35.82,22.831C-16.364,11.386,-4.298,-21.658,11.357,-19.739C18.401,-18.876,30.577,-18.908,36.57,-12.113Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i39",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i45",
    transform: "matrix(1,0,0,1,504.827,820.32)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-43.34,20.309C-43.34,20.309,43.341,-20.309,43.341,-20.309"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i46",
    transform: "matrix(1,0,0,1,490.201,850.064)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-45.348,21.231C-45.348,21.231,45.348,-21.231,45.348,-21.231"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i48",
    transform: "matrix(1,0,0,1,448.032,655.67)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-37.319,19.823C-37.319,19.823,37.319,-19.823,37.319,-19.823"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i24",
    transform: "matrix(1,0,0,1,414.027,691.718)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-49.125,23.628C-49.125,23.628,49.125,-23.628,49.125,-23.628"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,406.203,741.663)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-57.193,29.419C-57.193,29.419,57.193,-29.419,57.193,-29.419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,389.407,780.282)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-16.796,11.247C-16.796,11.247,16.796,-11.247,16.796,-11.247"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,400.797,722.197)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M53.697,-26.128C53.697,-26.128,-53.697,26.128,-53.697,26.128"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,439.542,532.857)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-45.809,25.51C-45.809,25.51,45.809,-25.51,45.809,-25.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,515.394,871.295)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-25.193,11.795C-25.193,11.795,25.193,-11.795,25.193,-11.795"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "i53"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i54"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(600.27,534.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-10)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-10; 0; 5; -10; 5; 0; -10; -10",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-600.27,-534.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i55"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,617.843,516.673)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#1a1a1a",
    fill: "#1a1a1a",
    d: "M5.758,-10.492C5.758,-10.492,8.844,6.789,5.758,8.641C2.672,10.492,-8.845,7.406,-8.64,6.378C-8.437,5.349,-5.977,-8.64,-5.977,-8.64C-5.977,-8.64,5.758,-10.492,5.758,-10.492Z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "i53"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i56"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(624.973,524.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-13)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-13; 3; 0; 3; 0; 3; -13; -13",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-624.973,-524.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,661.98,579.439)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M29.98,20.477C25.5,21.301,20.554,22.937,10.296,27.04C-18.783,34.775,15.144,-40.297,-34.074,-55.43C-34.074,-55.43,-37.007,50.959,-37.007,50.959C-4.622,55.43,24.135,35.873,30.747,34.56C34.813,33.752,37.008,20.357,29.98,20.477Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,658.473,598.45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M-18.131,-40.632C-18.131,-40.632,-9.978,-26.025,-5.657,-3.601C-1.337,18.824,28.288,18.825,28.288,18.825C28.288,18.825,14.093,37.752,11.829,39.193C9.566,40.632,-11.332,37.396,-11.332,37.396C-11.332,37.396,-27.465,-1.006,-27.876,-2.406C-28.288,-3.805,-18.131,-40.632,-18.131,-40.632Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,699.208,613.547)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc9590",
    d: "M-6.789,-12.216C-6.789,-12.216,7.097,-11.394,9.978,-6.765C12.857,-2.136,12.344,8.048,12.344,8.048C12.344,8.048,7.798,12.216,2.057,8.768C-3.685,5.32,-3.909,-1.519,-7.921,-1.93C-12.858,-5.633,-9.875,-11.29,-6.789,-12.216Z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "i57"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(635.519,657.221)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-635.519,-657.221)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(689.64,868.104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(11)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "11; 0; 11; 0; 11; 11",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "translate(-689.64,-868.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i24",
    transform: "matrix(1,0,0,1,673.963,916.24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M6.263,-34.309C5.708,-33.693,-4.29,-37.861,-11.455,-29.075C-18.62,-20.288,-1.286,37.861,8.651,37.143C18.586,36.425,18.332,9.254,18.477,-6.594C18.62,-22.443,6.263,-34.309,6.263,-34.309Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,685.656,881.669)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#572658",
    d: "M10.47,-6.049C10.47,-6.049,2.678,16.85,2.678,16.85C2.678,16.85,-10.44,12.847,-10.47,1.114C-3.911,-15.463,-3.593,-16.849,-3.593,-16.849C-3.593,-16.849,9.546,-12.454,10.47,-6.049Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,690.669,920.383)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.47,
    stroke: "#ffcf4a",
    d: "M5.457,-19.545C5.457,-19.545,-15.635,-17.623,-10.286,-12.412C-4.937,-7.2,20.985,-13.784,8.367,-7.749C-4.251,-1.715,-20.984,-4.32,-10.148,-1.441C0.686,1.439,16.87,1.577,9.602,5.829C2.332,10.08,-13.441,9.394,-6.995,12.138C-0.549,14.881,4.526,19.544,4.526,19.544"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,698.519,770.309)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M78.217,-38.966C74.113,5.564,-0.881,125.088,-0.881,125.088C-8.574,124.435,-15.345,117.59,-21.307,105.302C-22.133,103.605,-22.94,101.799,-23.737,99.893C-23.737,99.893,20.799,-17.87,13.18,-42.481C8.585,-57.338,-25.272,-75.612,-51.379,-87.761C-68.515,-95.733,-82.316,-101.071,-82.316,-101.071C-82.316,-101.071,-44.233,-125.088,-44.233,-125.088C-44.233,-125.088,82.316,-83.49,78.217,-38.966Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,700.539,769.697)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M-23.327,105.914C-24.152,104.218,-24.961,102.41,-25.758,100.505C-25.758,100.505,18.779,-17.258,11.16,-41.868C6.566,-56.726,-27.292,-74.999,-53.398,-87.148C-53.398,-87.148,-53.398,-101.607,-53.398,-101.607C-53.398,-101.607,-35.125,-105.913,-35.125,-105.913C-17.561,-102.429,14.617,-84.897,34.362,-53.856C53.399,-23.935,-17.209,97.193,-23.327,105.914Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,768.984,731.231)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#ffffff",
    d: "M1.535,-9.002C1.535,-9.002,-4.389,-0.05,-4.389,-0.05C-4.389,-0.05,4.389,-0.05,4.389,-0.05C4.389,-0.05,-3.017,6.533,-3.017,6.533C-3.017,6.533,1.535,9.002,1.535,9.002"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "i58"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(602,651)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 3; 0; 3; 0; 0",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-602,-651)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(774.397,888.573)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 8; 0; 8; 0; 0",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i24",
    transform: "translate(-774.397,-888.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i48",
    transform: "matrix(1,0,0,1,793.128,938.031)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M-17.68,-32.376C-17.812,-31.558,-28.473,-29.645,-29.737,-18.378C-30.999,-7.111,15.073,32.376,23.036,26.39C30.999,20.403,16.065,-2.296,7.6,-15.696C-0.864,-29.096,-17.68,-32.376,-17.68,-32.376Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i24",
    transform: "matrix(1,0,0,1,779.487,902.9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#572658",
    d: "M5.908,-11.164C5.908,-11.164,11.763,12.306,11.763,12.306C11.763,12.306,-1.432,16.047,-7.813,6.201C-11.279,-11.286,-11.763,-12.623,-11.763,-12.623C-11.763,-12.623,1.662,-16.047,5.908,-11.164Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,796.892,929.041)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.47,
    stroke: "#ffcf4a",
    d: "M3.844,-18.43C3.844,-18.43,-21.05,-3.994,-9.529,-4.818C1.992,-5.64,14.997,-13.573,11.478,-6.874C7.958,-0.177,-3.974,6.087,3.638,7.321C11.25,8.555,21.051,1.276,18.45,7.321C15.85,13.365,-1.415,15.49,8.369,16.784C18.155,18.079,18.878,18.43,18.878,18.43"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,673.325,775.503)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M119.227,114.035C118.753,116.003,117.847,117.625,116.6,118.953C110.211,125.861,95.014,124.891,85.957,123.558C81.704,122.935,78.8,122.237,78.8,122.237C78.8,122.237,42.478,-34.198,-38.375,-48.847C-119.227,-63.49,-117.616,-107.004,-117.616,-107.004C-117.616,-107.004,-111.463,-112.852,-98.061,-117.29C-82.154,-122.566,-56.03,-125.861,-17.867,-115.05C8.545,-107.524,29.71,-91.426,46.813,-70.797C46.813,-70.797,46.819,-70.792,46.819,-70.792C46.819,-70.786,46.819,-70.78,46.825,-70.775C92.295,-15.902,109.01,71.035,119.227,114.035Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,756.351,799.592)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M36.201,89.946C35.727,91.914,34.821,93.536,33.574,94.864C31.053,89.138,29.585,79.662,26.487,65.225C7.015,-25.502,-35.295,-92.895,-36.201,-94.864C9.269,-39.991,25.984,46.946,36.201,89.946Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,656.69,778.637)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M102.592,120.424C98.338,119.801,95.435,119.103,95.435,119.103C95.435,119.103,59.113,-37.333,-21.74,-51.981C-102.592,-66.625,-100.982,-110.138,-100.982,-110.138C-100.982,-110.138,-94.829,-115.985,-81.426,-120.424C-70.697,-99.182,-46.679,-68.172,4.13,-58.908C71.696,-46.591,96.595,81.793,102.592,120.424Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,731.018,744.388)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#ffffff",
    d: "M-0.163,-9.011C-0.163,-9.011,-8.066,4.392,-8.066,4.392C-8.066,4.392,5.872,-0.864,5.872,-0.864C5.872,-0.864,1.208,9.011,1.208,9.011C1.208,9.011,8.066,9.011,8.066,9.011"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "i53"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,610.195,595.384)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde70",
    d: "M59.029,49.837C51.705,77.369,-57.367,76.497,-57.367,76.497C-57.367,76.497,-59.029,19.31,-55.768,-21.122C-55.237,-27.708,-54.574,-33.849,-53.754,-39.223C-48.859,-71.303,-23.872,-72.619,-23.872,-72.619C-1.575,-77.369,13.922,-75.309,24.968,-68.111C34.381,-53.513,40.409,-35.759,39.831,-11.841C39.162,0.228,39.861,9.146,41.529,16.378C44.744,30.316,51.549,37.97,59.029,49.837Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,610.195,623.507)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M59.029,21.714C51.705,49.246,-57.367,48.374,-57.367,48.374C-57.367,48.374,-59.029,-8.813,-55.768,-49.245C-43.243,-36.922,-21.068,-19.243,3.122,-19.191C24.674,-19.145,35.901,-15.116,41.529,-11.745C44.744,2.193,51.549,9.847,59.029,21.714Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,604.076,558.336)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M5.124,18.616C6.808,13.782,4.404,-9.26,2.964,-20.616C-0.944,-17.324,-6.808,-17.284,-6.808,-17.284C-6.808,-17.284,-6.294,-15.432,-6.294,-15.432C-6.294,-15.432,0.187,-14.918,1.729,-17.489C2.759,-9.363,3.787,19.199,3.787,19.199C3.787,19.199,4.427,20.616,5.124,18.616Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "i53"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i56"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(624.973,524.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-13)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-13; 3; 0; 3; 0; 3; -13; -13",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-624.973,-524.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i48",
    transform: "matrix(1,0,0,1,695.873,649.067)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M-22.501,14.717C-22.501,14.717,22.502,-14.717,22.502,-14.717C22.502,-14.717,20.171,-14.717,20.171,-14.717C20.171,-14.717,-19.295,8.171,-19.295,8.171C-19.295,8.171,-22.501,14.717,-22.501,14.717Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i24",
    transform: "matrix(1,0,0,1,647.14,652.161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M-27.053,-11.624C-27.053,-11.624,29.727,5.531,29.727,5.531C29.727,5.531,26.231,11.623,26.231,11.623C26.231,11.623,-29.727,-6.942,-29.727,-6.942C-29.727,-6.942,-27.053,-11.624,-27.053,-11.624Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,671.519,635.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b546b",
    d: "M10.287,-21.847C8.435,-21.436,-51.432,4.692,-51.432,4.692C-51.432,4.692,5.35,21.847,5.35,21.847C5.35,21.847,51.433,-7.241,51.433,-7.241C51.433,-7.241,10.287,-21.847,10.287,-21.847Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,703.167,628.958)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M23.694,-30.596C23.694,-30.596,-26.59,28.281,-26.59,28.281C-26.59,28.281,-22.862,30.596,-22.862,30.596C-22.862,30.596,26.59,-27.626,26.59,-27.626C26.59,-27.626,23.694,-30.596,23.694,-30.596Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,752.529,585.743)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M23.837,-15.589C23.837,-15.589,-25.668,12.62,-25.668,12.62C-25.668,12.62,-22.771,15.589,-22.771,15.589C-22.771,15.589,25.668,-12.699,25.668,-12.699C25.668,-12.699,23.837,-15.589,23.837,-15.589Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,729.252,616.298)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b546b",
    d: "M-48.946,43.255C-48.946,43.255,2.547,12.567,2.547,12.567C2.547,12.567,48.946,-43.255,48.946,-43.255C48.946,-43.255,0.506,-14.967,0.506,-14.967C0.506,-14.967,-48.946,43.255,-48.946,43.255Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,728.646,618.093)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M2.372,-5.588C2.372,-5.588,-2.373,1.445,-2.373,1.445C-2.373,1.445,-2.373,5.588,-2.373,5.588C-2.373,5.588,2.372,0,2.372,0C2.372,0,2.372,-5.588,2.372,-5.588Z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "i53"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i60"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.843,526.984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-19)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-19; 0; 11; 0; 11; 0; -19; -19",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-576.843,-526.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,574.074,597.02)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde70",
    d: "M41.964,40.619C25.964,49.542,-25.848,64.025,-41.08,10.717C-52.832,-30.402,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-13.081,-23.584,-13.081,-23.584C-22.98,18.36,10.894,38.218,29.168,30.91C32.469,29.589,35.263,28.504,37.704,27.598C42.368,27.511,45.155,30.414,45.635,33.623C46.027,36.238,44.879,39.06,41.964,40.619Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M41.964,40.619C25.964,49.542,-25.848,64.025,-41.08,10.717C-52.832,-30.402,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-13.081,-23.584,-13.081,-23.584C-22.98,18.36,10.894,38.218,29.168,30.91C32.469,29.589,35.263,28.504,37.704,27.598C42.368,27.511,45.155,30.414,45.635,33.623C46.027,36.238,44.879,39.06,41.964,40.619Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-16.836,-19.589,-16.836,-19.589C-26.735,22.355,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M47.512,30.856C29.926,40.23,-28.574,70.48,-44.01,19.227C-56.342,-21.722,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.884,-23.307,-8.884,-23.307C-43.045,28.419,19.379,26.143,37.653,18.835C40.954,17.514,44.248,15.929,46.689,15.023C51.353,14.936,52.772,17.918,53.995,20.923C56.613,27.355,50.676,29.48,47.512,30.856Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.138,-23.317,-8.138,-23.317C-27.04,22.111,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M47.512,30.856C29.926,40.23,-28.574,70.48,-44.01,19.227C-56.342,-21.722,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.884,-23.307,-8.884,-23.307C-43.045,28.419,19.379,26.143,37.653,18.835C40.954,17.514,44.248,15.929,46.689,15.023C51.353,14.936,52.772,17.918,53.995,20.923C56.613,27.355,50.676,29.48,47.512,30.856Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-16.836,-19.589,-16.836,-19.589C-26.735,22.355,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M47.512,30.856C29.926,40.23,-28.574,70.48,-44.01,19.227C-56.342,-21.722,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.884,-23.307,-8.884,-23.307C-43.045,28.419,19.379,26.143,37.653,18.835C40.954,17.514,44.248,15.929,46.689,15.023C51.353,14.936,52.772,17.918,53.995,20.923C56.613,27.355,50.676,29.48,47.512,30.856Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.138,-23.317,-8.138,-23.317C-27.04,22.111,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M47.512,30.856C29.926,40.23,-28.574,70.48,-44.01,19.227C-56.342,-21.722,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.884,-23.307,-8.884,-23.307C-43.045,28.419,19.379,26.143,37.653,18.835C40.954,17.514,44.248,15.929,46.689,15.023C51.353,14.936,52.772,17.918,53.995,20.923C56.613,27.355,50.676,29.48,47.512,30.856Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-16.836,-19.589,-16.836,-19.589C-26.735,22.355,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M41.964,40.619C25.964,49.542,-25.848,64.025,-41.08,10.717C-52.832,-30.402,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-13.081,-23.584,-13.081,-23.584C-22.98,18.36,10.894,38.218,29.168,30.91C32.469,29.589,35.263,28.504,37.704,27.598C42.368,27.511,45.155,30.414,45.635,33.623C46.027,36.238,44.879,39.06,41.964,40.619Z; M41.964,40.619C25.964,49.542,-25.848,64.025,-41.08,10.717C-52.832,-30.402,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-13.081,-23.584,-13.081,-23.584C-22.98,18.36,10.894,38.218,29.168,30.91C32.469,29.589,35.263,28.504,37.704,27.598C42.368,27.511,45.155,30.414,45.635,33.623C46.027,36.238,44.879,39.06,41.964,40.619Z",
    keyTimes: "0; 0.166667; 0.255555; 0.333334; 0.422222; 0.5; 0.588889; 0.666667; 0.755556; 0.833334; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,574.074,603.637)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M41.964,34.002C25.964,42.925,-25.701,58.516,-40.933,5.208C-52.685,-35.911,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-41.258,-29.009,-31.758,2.263C-18.447,46.072,30.57,34.331,45.635,27.006C46.027,29.621,44.879,32.443,41.964,34.002Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M41.964,34.002C25.964,42.925,-25.701,58.516,-40.933,5.208C-52.685,-35.911,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-41.258,-29.009,-31.758,2.263C-18.447,46.072,30.57,34.331,45.635,27.006C46.027,29.621,44.879,32.443,41.964,34.002Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M47.324,24.302C27.551,34.114,-28.699,63.363,-44.01,12.61C-56.361,-28.333,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,38.867,21.443,53.932,14.118C56.738,20.238,51.488,22.801,47.324,24.302Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M47.324,24.302C27.551,34.114,-28.699,63.363,-44.01,12.61C-56.361,-28.333,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,38.867,21.443,53.932,14.118C56.738,20.238,51.488,22.801,47.324,24.302Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M47.324,24.302C27.551,34.114,-28.699,63.363,-44.01,12.61C-56.361,-28.333,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,38.867,21.443,53.932,14.118C56.738,20.238,51.488,22.801,47.324,24.302Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M47.324,24.302C27.551,34.114,-28.699,63.363,-44.01,12.61C-56.361,-28.333,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,38.867,21.443,53.932,14.118C56.738,20.238,51.488,22.801,47.324,24.302Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M41.964,34.002C25.964,42.925,-25.701,58.516,-40.933,5.208C-52.685,-35.911,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-41.258,-29.009,-31.758,2.263C-18.447,46.072,30.57,34.331,45.635,27.006C46.027,29.621,44.879,32.443,41.964,34.002Z; M41.964,34.002C25.964,42.925,-25.701,58.516,-40.933,5.208C-52.685,-35.911,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-41.258,-29.009,-31.758,2.263C-18.447,46.072,30.57,34.331,45.635,27.006C46.027,29.621,44.879,32.443,41.964,34.002Z",
    keyTimes: "0; 0.166667; 0.255555; 0.333334; 0.422222; 0.5; 0.588889; 0.666667; 0.755556; 0.833334; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(622.094,623.184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -24; 0; -24; 0; -24; 0; -24; 0; -24; 0; 0",
    keyTimes: "0; 0.166667; 0.255555; 0.333334; 0.422222; 0.5; 0.588889; 0.666667; 0.755556; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "translate(16.115,2.886)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc9590",
    d: "M-25.679,0.28C-25.679,0.28,-9.838,-5.377,-1.609,-1.674C6.62,2.029,8.986,22.191,8.986,22.191C8.986,22.191,8.471,23.528,6.209,22.191C3.946,20.853,0.448,8.98,0.448,8.98C0.448,8.98,-0.786,15.299,-6.033,16.739C-11.279,18.179,-17.034,13.858,-18.425,12.213C-19.816,10.567,-25.679,9.926,-25.679,9.926C-25.679,9.926,-28.456,4.6,-25.679,0.28Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M-25.679,0.28C-25.679,0.28,-9.838,-5.377,-1.609,-1.674C6.62,2.029,8.986,22.191,8.986,22.191C8.986,22.191,8.471,23.528,6.209,22.191C3.946,20.853,0.448,8.98,0.448,8.98C0.448,8.98,-0.786,15.299,-6.033,16.739C-11.279,18.179,-17.034,13.858,-18.425,12.213C-19.816,10.567,-25.679,9.926,-25.679,9.926C-25.679,9.926,-28.456,4.6,-25.679,0.28Z; M-15.944,-8.796C-15.944,-8.796,-0.103,-14.453,8.126,-10.75C16.355,-7.047,18.721,13.115,18.721,13.115C18.721,13.115,18.206,14.452,15.944,13.115C13.681,11.777,10.183,-0.096,10.183,-0.096C10.183,-0.096,8.949,6.224,3.702,7.664C-1.544,9.104,-7.299,4.783,-8.69,3.138C-10.081,1.492,-15.944,0.851,-15.944,0.851C-15.944,0.851,-18.721,-4.476,-15.944,-8.796Z; M-16.944,-13.296C-16.944,-13.296,-1.103,-18.953,7.126,-15.25C15.355,-11.547,17.721,8.615,17.721,8.615C17.721,8.615,17.206,9.952,14.944,8.615C12.681,7.277,9.183,-4.596,9.183,-4.596C9.183,-4.596,7.949,1.724,2.702,3.164C-2.544,4.604,-8.299,0.283,-9.69,-1.362C-11.081,-3.008,-16.944,-3.649,-16.944,-3.649C-16.944,-3.649,-19.721,-8.976,-16.944,-13.296Z; M-16.477,-8.212C-16.477,-8.212,-0.636,-13.869,7.593,-10.166C15.822,-6.463,18.188,13.699,18.188,13.699C18.188,13.699,17.673,15.036,15.411,13.699C13.148,12.361,9.65,0.488,9.65,0.488C9.65,0.488,8.416,6.807,3.169,8.247C-2.077,9.687,-7.832,5.366,-9.223,3.721C-10.614,2.075,-16.477,1.434,-16.477,1.434C-16.477,1.434,-19.254,-3.892,-16.477,-8.212Z; M-16.944,-13.296C-16.944,-13.296,-1.103,-18.953,7.126,-15.25C15.355,-11.547,17.721,8.615,17.721,8.615C17.721,8.615,17.206,9.952,14.944,8.615C12.681,7.277,9.183,-4.596,9.183,-4.596C9.183,-4.596,7.949,1.724,2.702,3.164C-2.544,4.604,-8.299,0.283,-9.69,-1.362C-11.081,-3.008,-16.944,-3.649,-16.944,-3.649C-16.944,-3.649,-19.721,-8.976,-16.944,-13.296Z; M-16.477,-8.212C-16.477,-8.212,-0.636,-13.869,7.593,-10.166C15.822,-6.463,18.188,13.699,18.188,13.699C18.188,13.699,17.673,15.036,15.411,13.699C13.148,12.361,9.65,0.488,9.65,0.488C9.65,0.488,8.416,6.807,3.169,8.247C-2.077,9.687,-7.832,5.366,-9.223,3.721C-10.614,2.075,-16.477,1.434,-16.477,1.434C-16.477,1.434,-19.254,-3.892,-16.477,-8.212Z; M-16.944,-13.296C-16.944,-13.296,-1.103,-18.953,7.126,-15.25C15.355,-11.547,17.721,8.615,17.721,8.615C17.721,8.615,17.206,9.952,14.944,8.615C12.681,7.277,9.183,-4.596,9.183,-4.596C9.183,-4.596,7.949,1.724,2.702,3.164C-2.544,4.604,-8.299,0.283,-9.69,-1.362C-11.081,-3.008,-16.944,-3.649,-16.944,-3.649C-16.944,-3.649,-19.721,-8.976,-16.944,-13.296Z; M-16.477,-8.212C-16.477,-8.212,-0.636,-13.869,7.593,-10.166C15.822,-6.463,18.188,13.699,18.188,13.699C18.188,13.699,17.673,15.036,15.411,13.699C13.148,12.361,9.65,0.488,9.65,0.488C9.65,0.488,8.416,6.807,3.169,8.247C-2.077,9.687,-7.832,5.366,-9.223,3.721C-10.614,2.075,-16.477,1.434,-16.477,1.434C-16.477,1.434,-19.254,-3.892,-16.477,-8.212Z; M-16.944,-13.296C-16.944,-13.296,-1.103,-18.953,7.126,-15.25C15.355,-11.547,17.721,8.615,17.721,8.615C17.721,8.615,17.206,9.952,14.944,8.615C12.681,7.277,9.183,-4.596,9.183,-4.596C9.183,-4.596,7.949,1.724,2.702,3.164C-2.544,4.604,-8.299,0.283,-9.69,-1.362C-11.081,-3.008,-16.944,-3.649,-16.944,-3.649C-16.944,-3.649,-19.721,-8.976,-16.944,-13.296Z; M-16.477,-8.212C-16.477,-8.212,-0.636,-13.869,7.593,-10.166C15.822,-6.463,18.188,13.699,18.188,13.699C18.188,13.699,17.673,15.036,15.411,13.699C13.148,12.361,9.65,0.488,9.65,0.488C9.65,0.488,8.416,6.807,3.169,8.247C-2.077,9.687,-7.832,5.366,-9.223,3.721C-10.614,2.075,-16.477,1.434,-16.477,1.434C-16.477,1.434,-19.254,-3.892,-16.477,-8.212Z; M-25.679,0.28C-25.679,0.28,-9.838,-5.377,-1.609,-1.674C6.62,2.029,8.986,22.191,8.986,22.191C8.986,22.191,8.471,23.528,6.209,22.191C3.946,20.853,0.448,8.98,0.448,8.98C0.448,8.98,-0.786,15.299,-6.033,16.739C-11.279,18.179,-17.034,13.858,-18.425,12.213C-19.816,10.567,-25.679,9.926,-25.679,9.926C-25.679,9.926,-28.456,4.6,-25.679,0.28Z; M-25.679,0.28C-25.679,0.28,-9.838,-5.377,-1.609,-1.674C6.62,2.029,8.986,22.191,8.986,22.191C8.986,22.191,8.471,23.528,6.209,22.191C3.946,20.853,0.448,8.98,0.448,8.98C0.448,8.98,-0.786,15.299,-6.033,16.739C-11.279,18.179,-17.034,13.858,-18.425,12.213C-19.816,10.567,-25.679,9.926,-25.679,9.926C-25.679,9.926,-28.456,4.6,-25.679,0.28Z",
    keyTimes: "0; 0.166667; 0.255555; 0.333334; 0.422222; 0.5; 0.588889; 0.666667; 0.755556; 0.833334; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "i53"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i54"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(600.27,534.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-10)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-10; 0; 5; -10; 5; 0; -10; -10",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-600.27,-534.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,611.045,493.766)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc9590",
    d: "M1.055,36.032C1.055,36.032,2.301,17.669,2.301,17.669C2.301,17.669,28.467,26.54,29.289,-16.593C29.789,-42.765,6.621,-49.215,-6.854,-35.447C-20.33,-21.678,-12.6,1.757,-15.879,11.718C-18.053,18.322,-25.619,27.838,-28.383,33.708C-29.788,36.691,-7.733,49.215,1.055,36.032Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,611.488,481.163)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M-43.283,47.879C-43.283,47.879,-30.273,43.941,-22.86,42.572C-5.853,38.527,-8.185,20.697,-9.282,8.079C-10.379,-4.539,-5.442,-7.282,-3.247,-5.911C-1.053,-4.539,6.457,-7.008,8.599,-12.22C22.263,-11.945,21.155,0.864,32.178,3.058C32.178,3.058,44.38,-14.414,35.653,-26.483C26.926,-38.553,14.308,-34.164,14.308,-34.164C14.308,-34.164,-1.327,-47.879,-18.06,-33.341C-34.792,-18.803,-44.38,38.071,-43.283,47.879Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,587.013,452.691)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M19.924,-8.435C19.924,-8.435,15.745,-29.625,-2.089,-20.779C-19.924,-11.932,-9.083,29.625,-9.083,29.625C-9.083,29.625,19.924,-8.435,19.924,-8.435Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,608.337,510.915)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#db6767",
    d: "M-4.816,-6.174C0.095,-1.648,5.008,0.52,5.008,0.52C5.008,0.52,4.624,6.174,4.624,6.174C4.624,6.174,-5.008,-3.02,-4.816,-6.174Z"
  }))))))))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i61"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,266.426,678.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.533,242.741",
    strokeDasharray: "5.678 5.678",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#1a1a1a"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    fill: "freeze",
    dur: "6s",
    begin: "0s",
    calcMode: "discrete",
    keyTimes: "0; 0.002778; 0.008333; 0.013889; 0.019444; 0.025; 0.030556; 0.036111; 0.041667; 0.047222; 0.052778; 0.058333; 0.063889; 0.069444; 0.075; 0.080556; 0.086111; 0.091667; 0.097222; 0.102778; 0.108333; 0.113889; 0.119444; 0.125; 0.130556; 0.136111; 0.141667; 0.147222; 0.152778; 0.158333; 0.163889; 0.169444; 0.175; 0.180556; 0.186111; 0.191667; 0.197222; 0.202778; 0.208333; 0.213889; 0.219444; 0.225; 0.230556; 0.236111; 0.241667; 0.247222; 0.252778; 0.258333; 0.263889; 0.269444; 0.275; 0.280556; 0.286111; 0.291667; 0.297222; 0.302778; 0.308333; 0.313889; 0.319444; 0.325; 0.330556; 0.336111; 0.341667; 0.347222; 0.352778; 0.358333; 0.363889; 0.369444; 0.375; 0.380556; 0.386111; 0.391667; 0.397222; 0.402778; 0.408333; 0.413889; 0.419444; 0.425; 0.430556; 0.436111; 0.441667; 0.447222; 0.452778; 0.458333; 0.463889; 0.469444; 0.475; 0.480556; 0.486111; 0.491667; 0.497222; 0.502778; 0.508333; 0.513889; 0.519444; 0.525; 0.530556; 0.536111; 0.541667; 0.547222; 0.552778; 0.558333; 0.563889; 0.569444; 0.575; 0.580556; 0.586111; 0.591667; 0.597222; 0.602778; 0.608333; 0.613889; 0.619444; 0.625; 0.630556; 0.636111; 0.641667; 0.647222; 0.652778; 0.658333; 0.663889; 0.669444; 0.675; 0.680556; 0.686111; 0.691667; 0.697222; 0.702778; 0.708333; 0.713889; 0.719444; 0.725; 0.730556; 0.736111; 0.741667; 0.747222; 0.752778; 0.758333; 0.763889; 0.769444; 0.775; 0.780556; 0.786111; 0.791667; 0.797222; 0.802778; 0.808333; 0.813889; 0.819444; 0.825; 0.830556; 0.836111; 0.841667; 0.847222; 0.852778; 0.858333; 0.863889; 0.869444; 0.875; 0.880556; 0.886111; 0.891667; 0.897222; 0.902778; 0.908333; 0.913889; 0.919444; 0.925; 0.930556; 0.936111; 0.941667; 0.947222; 0.952778; 0.958333; 0.963889; 0.969444; 0.975; 0.980556; 0.986111; 0.991667; 1",
    values: "M200.533,242.741; M200.533,242.741C200.214,242.708,199.896,242.674,199.577,242.641; M200.533,242.741C199.278,242.611,198.028,242.477,196.783,242.341; M200.533,242.741C197.742,242.451,194.976,242.147,192.236,241.828; M200.533,242.741C195.616,242.231,190.778,241.675,186.02,241.073; M200.533,242.741C192.903,241.95,185.466,241.047,178.22,240.037; M200.533,242.741C189.575,241.605,179.016,240.238,168.846,238.654; M200.533,242.741C185.652,241.198,171.507,239.231,158.074,236.87; M200.533,242.741C181.121,240.728,162.959,237.993,146,234.604; M200.533,242.741C175.962,240.193,153.394,236.488,132.731,231.764; M200.533,242.741C170.116,239.587,142.771,234.66,118.306,228.222; M200.533,242.741C163.581,238.91,131.162,232.461,102.934,223.865; M200.533,242.741C156.28,238.153,118.529,229.811,86.691,218.523; M200.533,242.741C148.194,237.315,104.951,226.637,69.829,212.046; M200.533,242.741C139.267,236.389,90.465,222.841,52.561,204.245; M200.533,242.741C129.399,235.366,75.067,218.29,35.087,194.874; M200.533,242.741C118.522,234.239,58.843,212.841,17.745,183.7; M200.533,242.741C106.629,233.006,42.005,206.364,1.027,170.55; M200.533,242.741C93.66,231.661,24.713,198.683,-14.613,155.206; M200.533,242.741C79.703,230.215,7.352,189.696,-28.523,137.662; M200.533,242.741C64.779,228.667,-9.782,179.259,-40.17,117.885; M200.533,242.741C49.202,227.053,-26.088,167.455,-48.911,96.319; M200.533,242.741C33.181,225.392,-41.176,154.344,-54.424,73.377; M200.533,242.741C16.989,223.713,-54.694,140.094,-56.582,49.638; M200.533,242.741C0.904,222.046,-66.399,124.942,-55.499,25.738; M200.533,242.741C-15.02,220.395,-76.294,108.964,-51.425,1.995; M200.533,242.741C-30.629,218.777,-84.359,92.359,-44.693,-21.137; M200.533,242.741C-45.82,217.202,-90.655,75.301,-35.686,-43.313; M200.533,242.741C-60.67,215.662,-95.328,57.77,-24.68,-64.478; M200.533,242.741C-75.12,214.164,-98.47,39.9,-12.008,-84.411; M200.533,242.741C-89.163,212.709,-100.194,21.767,2.042,-102.996; M200.533,242.741C-102.846,211.29,-100.614,3.371,17.269,-120.207; M200.533,242.741C-116.063,209.92,-99.84,-15.08,33.318,-135.856; M200.533,242.741C-128.901,208.589,-97.977,-33.644,50.079,-150.015; M200.533,242.741C-141.288,207.305,-95.142,-52.155,67.265,-162.591; M200.533,242.741C-153.25,206.065,-91.437,-70.589,84.731,-173.621; M200.533,242.741C-164.705,204.877,-86.998,-88.755,102.192,-183.069; M200.533,242.741C-175.615,203.746,-81.961,-106.525,119.435,-190.975; M200.533,242.741C-185.987,202.671,-76.439,-123.843,136.333,-197.435; M200.533,242.741C-195.771,201.657,-70.575,-140.556,152.683,-202.529; M200.533,242.741C-204.877,200.713,-64.546,-156.442,168.223,-206.35; M200.533,242.741C-213.302,199.839,-58.478,-171.422,182.851,-209.058; M200.533,242.741C-220.96,199.046,-52.553,-185.275,196.333,-210.8; M200.533,242.741C-227.851,198.331,-46.889,-197.931,208.602,-211.761; M200.533,242.741C-233.937,197.7,-41.624,-209.264,219.536,-212.117; M200.533,242.741C-239.185,197.156,-36.887,-219.146,229.028,-212.042; M200.533,242.741C-243.518,196.707,-32.837,-227.387,236.907,-211.708; M200.533,242.741C-246.948,196.351,-29.544,-233.961,243.168,-211.266; M200.533,242.741C-249.443,196.093,-27.099,-238.772,247.735,-210.843; M200.533,242.741C-250.969,195.935,-25.583,-241.726,250.533,-210.543; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M200.536,242.741C-251.493,195.882,-25.06,-242.741,251.493,-210.433; M199.577,242.641C-251.172,195.262,-24.865,-242.716,251.491,-210.433; M196.624,242.324C-250.18,193.344,-24.26,-242.646,251.491,-210.433; M191.916,241.791C-248.583,190.271,-23.286,-242.532,251.491,-210.433; M185.46,241.002C-246.364,186.022,-21.933,-242.374,251.491,-210.433; M177.263,239.903C-243.494,180.566,-20.186,-242.17,251.491,-210.433; M167.576,238.455C-240.023,174.027,-18.076,-241.923,251.491,-210.433; M156.415,236.575C-235.909,166.363,-15.58,-241.632,251.491,-210.433; M143.954,234.191C-231.158,157.627,-12.705,-241.296,251.491,-210.433; M130.149,231.166C-225.683,147.71,-9.398,-240.91,251.491,-210.433; M115.28,227.414C-219.509,136.716,-5.68,-240.475,251.491,-210.433; M99.33,222.749C-212.52,124.517,-1.484,-239.985,251.491,-210.433; M82.612,217.048C-204.724,111.211,3.18,-239.44,251.491,-210.433; M65.32,210.132C-196.057,96.787,8.345,-238.837,251.491,-210.433; M47.541,201.72C-186.362,81.107,14.099,-238.165,251.491,-210.433; M29.722,191.641C-175.628,64.3,20.439,-237.424,251.491,-210.433; M12.241,179.667C-163.779,46.414,27.402,-236.611,251.491,-210.433; M-4.56,165.473C-150.65,27.397,35.074,-235.715,251.491,-210.433; M-19.964,149.006C-136.315,7.58,43.4,-234.742,251.491,-210.433; M-33.338,130.256C-120.827,-12.742,52.336,-233.698,251.491,-210.433; M-44.114,109.271C-104.229,-33.288,61.847,-232.587,251.491,-210.433; M-51.671,86.667C-86.936,-53.369,71.684,-231.438,251.491,-210.433; M-55.806,62.786C-69.075,-72.718,81.77,-230.26,251.491,-210.433; M-56.461,38.392C-51.047,-90.848,91.874,-229.079,251.491,-210.433; M-53.856,14.044C-33.079,-107.548,101.871,-227.911,251.491,-210.433; M-48.303,-9.893C-15.264,-122.784,111.712,-226.762,251.491,-210.433; M-40.187,-33.004C2.248,-136.507,121.317,-225.64,251.491,-210.433; M-29.844,-55.123C19.466,-148.811,130.698,-224.544,251.491,-210.433; M-17.6,-76.065C36.366,-159.765,139.844,-223.476,251.491,-210.433; M-3.852,-95.567C52.825,-169.384,148.696,-222.442,251.491,-210.433; M11.259,-113.722C68.998,-177.848,157.34,-221.432,251.491,-210.433; M27.319,-130.269C84.707,-185.147,165.687,-220.457,251.491,-210.433; M44.196,-145.273C100.047,-191.412,173.791,-219.51,251.491,-210.433; M61.657,-158.685C114.988,-196.71,181.641,-218.593,251.491,-210.433; M79.35,-170.398C129.391,-201.078,189.168,-217.714,251.491,-210.433; M97.178,-180.509C143.318,-204.621,196.411,-216.868,251.491,-210.433; M114.93,-189.04C156.722,-207.409,203.347,-216.057,251.491,-210.433; M132.24,-195.984C169.431,-209.497,209.894,-215.292,251.491,-210.433; M149.049,-201.493C181.495,-210.986,216.083,-214.57,251.491,-210.433; M165.16,-205.674C192.849,-211.953,221.883,-213.892,251.491,-210.433; M180.23,-208.635C203.314,-212.476,227.209,-213.27,251.491,-210.433; M194.252,-210.578C212.941,-212.648,232.093,-212.699,251.491,-210.433; M206.915,-211.664C221.558,-212.554,236.451,-212.19,251.491,-210.433; M218.25,-212.1C229.221,-212.275,240.315,-211.739,251.491,-210.433; M228.064,-212.066C235.823,-211.888,243.637,-211.351,251.491,-210.433; M236.345,-211.74C241.374,-211.459,246.424,-211.025,251.491,-210.433; M242.846,-211.292C245.722,-211.056,248.604,-210.77,251.491,-210.433; M247.574,-210.86C248.878,-210.728,250.184,-210.586,251.491,-210.433; M250.533,-210.543C250.852,-210.507,251.172,-210.471,251.491,-210.433; M251.491,-210.433; M251.491,-210.433",
    attributeName: "d"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,621.029,973.18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i1)",
    fillRule: "evenodd",
    d: "M-8.431,-53.59C-248.795,-53.115,-442.266,-32.432,-442.266,-6.986C-442.266,3.189,-411.33,12.602,-358.84,20.266C-360.221,22.308,-360.934,24.393,-360.934,26.512C-360.934,51.204,-264.087,71.219,-144.62,71.219C-46.406,71.219,36.518,57.692,62.914,39.16C277.373,35.94,442.267,16.507,442.267,-6.986C442.267,-15.785,419.129,-24.014,378.922,-31.036C367.95,-53.602,275.781,-71.219,163.703,-71.219C93.487,-71.219,31.088,-64.304,-8.431,-53.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,626.872,965.899)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6e696e",
    d: "M12.94,-7.318C12.94,1.927,2.582,10.343,-14.401,16.665C-14.401,16.665,-13.527,6.45,-13.527,6.45C-11.804,5.816,-10.154,5.161,-8.575,4.493C5.121,-1.339,13.538,-8.667,14.208,-16.665C14.222,-16.593,14.238,-16.516,14.253,-16.445C14.401,-15.668,12.94,-8.105,12.94,-7.318Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,522.421,971.148)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6e696e",
    d: "M90.925,1.201C90.925,1.201,90.051,11.417,90.051,11.417C71.01,18.505,43.645,22.95,13.234,22.95C-44.293,22.95,-90.925,7.047,-90.925,-12.567C-90.925,-13.501,-89.816,-22.035,-89.612,-22.95C-89.612,-3.332,-42.975,12.571,14.547,12.571C44.728,12.571,71.905,8.197,90.925,1.201Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,533.791,948.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb485c",
    d: "M95.54,-11.567C95.54,-11.567,3.176,-0.003,3.176,-0.003C3.176,-0.003,79.555,24.149,79.555,24.149C60.535,31.145,33.358,35.519,3.176,35.519C-54.345,35.519,-100.982,19.616,-100.982,-0.003C-100.982,-19.621,-54.345,-35.519,3.176,-35.519C48.085,-35.519,86.356,-25.83,100.982,-12.247C100.982,-12.247,95.54,-11.567,95.54,-11.567Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,589.047,954.151)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb485c",
    d: "M52.079,-5.953C52.079,-5.605,52.063,-5.258,52.033,-4.916C51.363,3.082,42.946,10.41,29.251,16.241C27.672,16.91,26.021,17.565,24.299,18.198C24.299,18.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,40.284,-17.517,40.284,-17.517C40.284,-17.517,45.726,-18.197,45.726,-18.197C49.835,-14.38,52.079,-10.256,52.079,-5.953Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i8)",
    transform: "matrix(1,0,0,1,600,600)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.703,347.151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 90; 164; 266; 360; 360",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.5,7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M44.049,25.948C44.049,25.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,45.771,25.315,44.049,25.948Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M44.049,25.948C44.049,25.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,45.771,25.315,44.049,25.948Z; M10.049,65.948C10.049,65.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,20.534,-33.017,20.534,-33.017C20.534,-33.017,11.771,65.315,10.049,65.948Z; M54.949,51.413C54.949,51.413,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,96.193,-8.646,96.193,-8.646C96.193,-8.646,56.671,50.78,54.949,51.413Z; M23.86,58.762C23.86,58.762,-52.08,-5.954,-52.08,-5.954C-52.08,-5.954,33.038,-36.736,33.038,-36.736C33.038,-36.736,25.582,58.129,23.86,58.762Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))))))), /*#__PURE__*/React.createElement("g", {
    display: "none",
    transform: "matrix(0.991,0,0,0.956,599.897,615.619)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-63.75,353.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1fff",
    d: "M0,-43C-29.426,-43,-56.057,-38.187,-75.298,-30.411C-94.427,-22.68,-106.25,-12.021,-106.25,-0.25C-106.25,7.747,-105.611,15.356,-96.113,21.757C-77.569,34.255,-38.805,42.5,0,42.5C39.656,42.5,76.647,34.133,94.902,21.178C103.659,14.963,107.011,4.654,107.011,-3C107.011,-7.915,104.917,-12.517,101.07,-16.724C86.44,-32.724,46.464,-43,0,-43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#i11)",
    transform: "matrix(1,0,0,1,600,600)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.703,347.151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 90; 164; 266; 360; 360",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.5,7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M39.549,24.198C39.549,24.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,41.271,23.565,39.549,24.198Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M39.549,24.198C39.549,24.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,41.271,23.565,39.549,24.198Z; M10.049,65.948C10.049,65.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,20.534,-33.017,20.534,-33.017C20.534,-33.017,11.771,65.315,10.049,65.948Z; M54.949,51.413C54.949,51.413,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,96.193,-8.646,96.193,-8.646C96.193,-8.646,56.671,50.78,54.949,51.413Z; M23.86,58.762C23.86,58.762,-52.08,-5.954,-52.08,-5.954C-52.08,-5.954,33.038,-36.736,33.038,-36.736C33.038,-36.736,25.582,58.129,23.86,58.762Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-63.703,347.151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 90; 164; 266; 360; 360",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.5,7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M39.549,24.198C39.549,24.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,41.271,23.565,39.549,24.198Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M39.549,24.198C39.549,24.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,41.271,23.565,39.549,24.198Z; M10.049,65.948C10.049,65.948,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,20.534,-33.017,20.534,-33.017C20.534,-33.017,11.771,65.315,10.049,65.948Z; M54.949,51.413C54.949,51.413,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,96.193,-8.646,96.193,-8.646C96.193,-8.646,56.671,50.78,54.949,51.413Z; M23.86,58.762C23.86,58.762,-52.08,-5.954,-52.08,-5.954C-52.08,-5.954,33.038,-36.736,33.038,-36.736C33.038,-36.736,25.582,58.129,23.86,58.762Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z; M66.049,32.198C66.049,32.198,-52.08,-5.953,-52.08,-5.953C-52.08,-5.953,70.034,-21.767,70.034,-21.767C70.034,-21.767,67.771,31.565,66.049,32.198Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))))))), /*#__PURE__*/React.createElement("g", {
    display: "none",
    transform: "matrix(1.006,0,0,1,600.506,600)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-63,348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1fff",
    d: "M0,-36C-57.161,-36,-103.5,-19.882,-103.5,0C-103.5,19.882,-57.161,36,0,36C57.161,36,103.5,19.882,103.5,0C103.5,-19.882,57.161,-36,0,-36Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.73,955.822)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1.05 1.05; 1 1; 1 1; 1.05 1.05; 1 1; 1 1",
    keyTimes: "0; 0.083333; 0.166667; 0.5; 0.583333; 0.666667; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.833 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-293.73,-955.822)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,282.812,890.213)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde70",
    d: "M64.608,27.462C60.4,70.065,-4.06,78.474,-34.604,45.118C-65.155,11.769,-2.935,-51.289,-2.935,-51.289C-2.935,-51.289,-11.068,-71.19,-11.068,-71.19C-11.068,-71.19,-5.324,-75.622,-1.116,-76.603C0.176,-76.909,1.318,-76.887,2.109,-76.315C5.468,-73.874,10.795,-72.869,21.445,-75.675C32.094,-78.474,35.177,-71.19,35.177,-71.19C35.177,-71.19,23.125,-50.451,23.125,-50.451C23.125,-50.451,57.699,-23.723,63.921,11.273C64.856,16.507,65.156,21.921,64.608,27.462Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,282.812,891.149)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M64.608,26.527C60.4,69.13,-4.06,77.539,-34.604,44.183C-65.155,10.834,-2.935,-52.224,-2.935,-52.224C-2.935,-52.224,-11.068,-72.125,-11.068,-72.125C-11.068,-72.125,-5.324,-76.558,-1.116,-77.539C1.874,-67.907,6.813,-50.689,4.47,-48.906C1.197,-46.407,-43.789,1.876,-15.258,27.929C8.966,50.059,49.815,45.008,63.921,10.338C64.856,15.572,65.156,20.986,64.608,26.527Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,292.53,850.541)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M1.198,-9.656C1.198,-9.656,3.994,5.479,-1.191,10.383C-3.994,11.224,-3.994,9.262,-3.994,9.262C-3.994,9.262,0.56,-1.668,-0.561,-9.656C0.016,-11.224,1.198,-9.656,1.198,-9.656Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,321.795,853.217)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M-19.945,-12.122C-19.945,-12.122,-2.382,12.519,15.835,8.689C19.946,3.924,15.18,3.082,15.18,3.082C15.18,3.082,-11.444,-4.719,-14.993,-12.122C-17.329,-12.519,-19.945,-12.122,-19.945,-12.122Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,292.367,840.792)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M-17.423,-3.643C-17.423,-3.643,7.147,0.747,15.648,-2.336C20.786,-1.682,17.516,0.373,17.516,0.373C17.516,0.373,-11.631,3.643,-16.489,-0.935C-20.786,-3.364,-17.423,-3.643,-17.423,-3.643Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,299.307,904.856)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-2.69,3.927C-4.504,3.308,-6.153,2.68,-7.638,2.04C-9.122,1.402,-10.401,0.628,-11.472,-0.279C-12.544,-1.185,-13.379,-2.267,-13.977,-3.525C-14.575,-4.783,-14.874,-6.318,-14.874,-8.134C-14.874,-10.936,-14.007,-13.298,-12.276,-15.215C-10.544,-17.132,-8.07,-18.44,-4.854,-19.141C-4.854,-19.141,-4.854,-24.151,-4.854,-24.151C-4.483,-24.233,-3.907,-24.337,-3.123,-24.46C-2.34,-24.584,-1.537,-24.645,-0.711,-24.645C0.897,-24.645,2.154,-24.368,3.061,-23.811C3.968,-23.255,4.422,-22.068,4.422,-20.255C4.422,-20.255,4.422,-19.451,4.422,-19.451C6.978,-19.12,9.03,-18.462,10.576,-17.471C12.122,-16.482,12.895,-15.122,12.895,-13.39C12.895,-12.317,12.647,-11.4,12.153,-10.637C11.658,-9.875,11.06,-9.225,10.359,-8.689C9.452,-9.266,8.236,-9.772,6.71,-10.205C5.185,-10.637,3.515,-10.854,1.701,-10.854C-0.155,-10.854,-1.515,-10.596,-2.38,-10.081C-3.247,-9.565,-3.679,-8.916,-3.679,-8.134C-3.679,-7.514,-3.412,-7.01,-2.876,-6.618C-2.34,-6.225,-1.537,-5.865,-0.463,-5.536C-0.463,-5.536,2.814,-4.484,2.814,-4.484C6.69,-3.247,9.668,-1.67,11.751,0.247C13.832,2.164,14.874,4.773,14.874,8.071C14.874,10.875,13.987,13.256,12.215,15.213C10.441,17.172,7.844,18.502,4.422,19.202C4.422,19.202,4.422,24.15,4.422,24.15C4.051,24.233,3.474,24.335,2.69,24.459C1.907,24.583,1.103,24.645,0.279,24.645C-1.33,24.645,-2.587,24.366,-3.494,23.81C-4.401,23.253,-4.854,22.068,-4.854,20.254C-4.854,20.254,-4.854,19.636,-4.854,19.636C-6.339,19.47,-7.69,19.202,-8.905,18.831C-10.123,18.46,-11.173,17.987,-12.06,17.409C-12.947,16.832,-13.636,16.152,-14.131,15.368C-14.626,14.585,-14.874,13.698,-14.874,12.709C-14.874,11.514,-14.524,10.493,-13.822,9.648C-13.122,8.803,-12.359,8.154,-11.534,7.699C-10.38,8.607,-8.967,9.391,-7.298,10.049C-5.628,10.709,-3.803,11.039,-1.824,11.039C0.196,11.039,1.618,10.73,2.443,10.112C3.268,9.493,3.68,8.772,3.68,7.947C3.68,7.122,3.35,6.493,2.69,6.061C2.03,5.627,1.103,5.205,-0.092,4.792C-0.092,4.792,-2.69,3.927,-2.69,3.927Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,906.631,890.966)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b080b0",
    d: "M-38.469,-21.874C-38.469,-21.874,-36.198,21.874,-36.198,21.874C-19.171,21.723,-2.081,11.411,12.907,3.501C20.165,-0.293,28.13,-3.283,36.329,-5.151C36.329,-5.151,38.469,-18.205,38.469,-18.205C38.469,-18.205,-38.469,-21.874,-38.469,-21.874Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,906.697,911.225)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#572658",
    d: "M-36.263,1.615C-36.263,1.615,-35.205,22,-35.205,22C-13.39,25.41,7.935,24.82,28.777,20.262C28.777,20.262,36.263,-25.41,36.263,-25.41C28.064,-23.542,20.099,-20.552,12.841,-16.758C-2.147,-8.848,-19.237,1.464,-36.263,1.615Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,913.088,870.272)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M35.179,0C35.179,2.061,19.428,3.731,-0.001,3.731C-19.429,3.731,-35.179,2.061,-35.179,0C-35.179,-2.061,-19.429,-3.73,-0.001,-3.73C19.428,-3.73,35.179,-2.061,35.179,0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(910.464,853.192)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 13; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-910.464,-853.192)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,972.043,787.879)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#339e7e",
    d: "M-61.71,64.69C-61.71,64.69,22.598,113.013,65.249,53.291C107.899,-6.431,89.421,-61.98,42.816,-87.497C-3.788,-113.013,-67.88,-93.155,-87.89,-62.14C-107.899,-31.126,-53.967,52.919,-61.71,64.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,943.945,803.529)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M63.113,-68.152C63.113,-68.152,19.752,28.824,-63.113,68.151"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1004.76,735.271)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M30.667,21.334C30.667,21.334,11.14,8.375,-6.098,16.459C-10.593,-2.879,-30.668,-21.334,-30.668,-21.334"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,988.026,751.906)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M44.831,36.065C44.831,36.065,15.446,14.462,1.211,17.051C-2.505,3.983,-17.611,-24.732,-44.831,-36.065"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,976.897,771.936)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M67.363,44.995C67.363,44.995,23.98,12.806,0.965,15.131C0.393,3.136,-26.168,-36.069,-67.362,-44.994"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,962.517,786.94)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M53.562,37.602C53.562,37.602,28.902,13.358,2.654,14.742C0.692,0.217,-27.627,-32.813,-53.562,-37.602"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,954.725,807.986)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M45.514,34.818C45.514,34.818,18.686,6.174,-2.855,9.957C-3.035,-5.718,-21.79,-25.399,-45.514,-34.818"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,947.317,823.887)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#10663f",
    d: "M41.636,31.233C41.636,31.233,21.343,10.34,-10.032,8.239C-11.466,-3.358,-26.53,-29.407,-41.635,-31.233"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(913.391,864.883)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 21; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-913.391,-864.883)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,988.684,899.123)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00593b",
    d: "M-46.424,-29.612C-46.424,-29.612,-4.115,-67.67,18.718,-51.038C41.551,-34.406,69.292,-3.307,43.568,29.286C17.845,61.881,-20.994,67.67,-45.144,34.727C-69.292,1.784,-39.057,-9.263,-46.424,-29.612Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,962.344,897.102)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M54.13,30.315C54.13,30.315,23.572,-24.086,-20.085,-27.591C-54.022,-30.315,-54.131,-27.35,-54.131,-27.35"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,965.607,878.161)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M21.235,-24.947C21.235,-24.947,3.439,-7.544,-9.499,-6.387C4.582,3.292,-13.673,20.948,-21.235,24.947"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,975.649,887.918)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M31.992,-29.31C31.992,-29.31,18.345,-12.01,-5.603,-10.582C1.255,-0.54,-7.771,21.987,-31.992,29.31"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,989.84,901.915)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M31.105,-25.807C31.105,-25.807,13.477,-8.903,-5.857,-13.513C-3.86,-5.204,-11.132,23.392,-31.106,25.807"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,997.346,920.47)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M32.323,-25.088C32.323,-25.088,10.052,-16.063,-0.158,-19.316C-1.94,-7.415,-2.948,17.072,-32.324,25.087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1009.258,925.816)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M13.417,-15.818C13.417,-15.818,3.754,-11.287,-2.188,-12.935C-0.943,-1.307,-6.053,12.643,-13.417,15.818"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(911.214,863.699)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 17; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-911.214,-863.699)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,848.717,850.381)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#127755",
    d: "M57.295,6.552C57.295,6.552,53.252,-52.681,24.071,-56.81C-5.109,-60.939,-48.475,-57.799,-52.885,-14.703C-57.295,28.393,-32.412,60.939,9.604,53.807C51.618,46.676,36.997,16.441,57.295,6.552Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,863.452,849.269)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-55.082,-2.876C-55.082,-2.876,8.324,-22.601,42.56,7.664C55.082,18.734,47.2,22.601,47.2,22.601"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,885.209,846.452)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-0.748,-34.107C-0.748,-34.107,-0.061,-8.148,8.789,2.117C-8.788,-0.862,-7.94,25.621,-5.182,34.107"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,868.501,846.465)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-3.534,-45.189C-3.534,-45.189,-5.881,-22.32,11.017,-3.857C-1.412,-1.317,-11.016,22.112,1.804,45.189"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,849.614,846.641)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-7.325,-41.921C-7.325,-41.921,-6.4,-16.457,11.428,-5.866C3.898,-1.094,-11.428,25.604,1.779,41.921"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,829.719,855.085)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-7.963,-42.267C-7.963,-42.267,2.161,-19.331,12.171,-14.352C4.86,-4.145,-12.171,14.926,4.008,42.267"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,818.129,850.437)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#3dbe88",
    d: "M-1.75,-21.592C-1.75,-21.592,2.194,-11.181,7.843,-8.099C-1.536,-0.294,-7.843,13.863,-4.633,21.592"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,600)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0.509; 1; 1",
    path: "M0 0 C0 3.333 0 23.333 0 20 C0 20 0 0 0 0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-600,-600)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.687,747.857)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -60; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i2)",
    fillRule: "evenodd",
    d: "M24.22,26.07C24.22,26.07,0,15.881,0,15.881C0,15.881,-24.22,5.69,-24.22,5.69C-24.22,5.69,-3.286,-10.19,-3.286,-10.19C-3.286,-10.19,17.649,-26.07,17.649,-26.07C17.649,-26.07,20.935,0,20.935,0C20.935,0,24.22,26.07,24.22,26.07Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(833.315,637.255)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 40; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i3)",
    d: "M18.351,4.807C18.351,4.807,-0.001,12.198,-0.001,12.198C-0.001,12.198,-18.351,19.588,-18.351,19.588C-18.351,19.588,-15.576,0,-15.576,0C-15.576,0,-12.799,-19.587,-12.799,-19.587C-12.799,-19.587,2.776,-7.391,2.776,-7.391C2.776,-7.391,18.351,4.807,18.351,4.807Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(822.847,754.976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 60; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i4)",
    fillRule: "evenodd",
    d: "M10.173,26.552C10.173,26.552,-8.548,5.873,-8.548,5.873C-8.548,5.873,-27.269,-14.807,-27.269,-14.807C-27.269,-14.807,0.001,-20.68,0.001,-20.68C0.001,-20.68,27.27,-26.553,27.27,-26.553C27.27,-26.553,18.721,0,18.721,0C18.721,0,10.173,26.552,10.173,26.552Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.544,911.366)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -40; 0; 0",
    keyTimes: "0; 0.5; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i5)",
    d: "M18.84,17.847C18.84,17.847,-0.001,14.784,-0.001,14.784C-0.001,14.784,-18.84,11.722,-18.84,11.722C-18.84,11.722,-6.768,-3.062,-6.768,-3.062C-6.768,-3.062,5.304,-17.847,5.304,-17.847C5.304,-17.847,12.072,0,12.072,0C12.072,0,18.84,17.847,18.84,17.847Z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(886.251,547.726)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 75; 25; -75; 0; 0",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.592 0 0.414 1; 0.592 0 0.414 1; 0.592 0 0.414 1; 0.592 0 0.414 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-886.251,-547.726)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,878.087,547.726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M8.164,0C8.164,0,34.57,42.833,34.57,42.833C26.893,47.577,17.85,50.313,8.164,50.313C-19.622,50.313,-42.149,27.792,-42.149,0C-42.149,-27.786,-19.622,-50.313,8.164,-50.313C21.267,-50.313,33.196,-45.304,42.149,-37.102C42.149,-37.102,8.164,0,8.164,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,911.408,562.594)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb485c",
    d: "M25.157,-14.869C25.157,-3.031,21.07,7.843,14.236,16.432C14.236,16.432,-25.156,-14.869,-25.156,-14.869C-25.156,-14.869,25.128,-16.432,25.128,-16.432C25.151,-15.913,25.157,-15.394,25.157,-14.869Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,911.393,529.175)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i6)",
    fillRule: "evenodd",
    d: "M-25.142,18.551C-25.142,18.551,25.143,16.986,25.143,16.986C24.715,2.932,18.522,-9.68,8.844,-18.551C8.844,-18.551,-25.142,18.551,-25.142,18.551Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,905.947,569.142)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M19.696,9.884C16.078,14.438,11.679,18.346,6.71,21.417C6.71,21.417,-19.697,-21.417,-19.697,-21.417C-19.697,-21.417,19.696,9.884,19.696,9.884Z"
  }))))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "i62"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,600)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0.248; 0.496; 0.752; 1; 1",
    path: "M0 0 C1.667 0 10 0 10 0 C10 0 0 0 0 0 C0 0 11.667 0 10 0 C10 0 0 0 0 0",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-600,-600)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,332.938,598.423)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6584c6",
    d: "M53.91,6.412C53.506,5.587,-55.133,35.54,-55.878,35.956C-55.52,35.252,-32.357,-9.843,9.922,-20.764C19.457,-23.234,29.968,-23.956,41.414,-22.039C54.042,-19.927,64.761,-15.281,73.378,-8.979C64.197,-7.379,58.779,-1.756,53.91,6.412Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M53.91,6.412C53.506,5.587,-55.133,35.54,-55.878,35.956C-55.52,35.252,-32.357,-9.843,9.922,-20.764C19.457,-23.234,29.968,-23.956,41.414,-22.039C54.042,-19.927,64.761,-15.281,73.378,-8.979C64.197,-7.379,58.779,-1.756,53.91,6.412Z; M45.16,0.412C44.756,-0.413,-63.883,29.54,-64.628,29.956C-64.27,29.252,-41.107,-15.843,1.172,-26.764C10.707,-29.234,21.218,-29.956,32.664,-28.039C45.292,-25.927,56.011,-21.281,64.628,-14.979C55.447,-13.379,50.029,-7.756,45.16,0.412Z; M45.16,0.412C44.756,-0.413,-63.883,29.54,-64.628,29.956C-64.27,29.252,-41.107,-15.843,1.172,-26.764C10.707,-29.234,26.468,-32.206,37.914,-30.289C50.542,-28.177,57.313,-26.423,67.378,-19.729C58.197,-18.129,50.029,-7.756,45.16,0.412Z; M44.91,9.662C44.506,8.837,-56.883,36.54,-57.628,36.956C-57.27,36.252,-41.357,-6.593,0.922,-17.514C10.457,-19.984,26.218,-20.956,37.664,-19.039C50.292,-16.927,58.563,-18.923,68.628,-12.229C59.447,-10.629,49.779,1.494,44.91,9.662Z; M53.91,6.412C53.506,5.587,-55.133,35.54,-55.878,35.956C-55.52,35.252,-32.357,-9.843,9.922,-20.764C19.457,-23.234,29.968,-23.956,41.414,-22.039C54.042,-19.927,64.761,-15.281,73.378,-8.979C64.197,-7.379,58.779,-1.756,53.91,6.412Z; M53.91,6.412C53.506,5.587,-55.133,35.54,-55.878,35.956C-55.52,35.252,-32.357,-9.843,9.922,-20.764C19.457,-23.234,29.968,-23.956,41.414,-22.039C54.042,-19.927,64.761,-15.281,73.378,-8.979C64.197,-7.379,58.779,-1.756,53.91,6.412Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,669.496,843.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M268.526,62.355C253.401,93.466,234.004,116.7,216.754,130.71C156.504,175.7,45.449,166.301,3.875,121.735C-108.162,4.094,-225.062,100.941,-235.493,56.65C-251.495,-11.3,-194.996,-62.8,-215.003,-82.63C-223.943,-91.491,-240.057,-88.847,-246.59,-88.506C-246.59,-88.506,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-102.745,-162.105,-102.745,-162.105C-95.691,-163.507,-81.188,-156.008,-72.339,-144.582C-24.496,-82.8,-143.996,-42.3,-122.838,8.577C-112.217,34.117,-62.188,3.492,18.053,-12.624C131.032,-35.313,125.768,22.515,201.806,65.903C232.75,87.351,242.189,77.167,268.526,62.355Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M268.526,62.355C253.401,93.466,234.004,116.7,216.754,130.71C156.504,175.7,45.449,166.301,3.875,121.735C-108.162,4.094,-225.062,100.941,-235.493,56.65C-251.495,-11.3,-194.996,-62.8,-215.003,-82.63C-223.943,-91.491,-240.057,-88.847,-246.59,-88.506C-246.59,-88.506,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-102.745,-162.105,-102.745,-162.105C-95.691,-163.507,-81.188,-156.008,-72.339,-144.582C-24.496,-82.8,-143.996,-42.3,-122.838,8.577C-112.217,34.117,-62.188,3.492,18.053,-12.624C131.032,-35.313,125.768,22.515,201.806,65.903C232.75,87.351,242.189,77.167,268.526,62.355Z; M268.526,81.355C253.401,112.466,239.257,129.924,219.754,139.71C129.082,175.507,26.449,154.301,-15.125,109.735C-72.496,38.7,-192.495,72.2,-235.493,56.65C-291.35,36.45,-153.059,-37.01,-215.003,-82.63C-225.139,-90.093,-233.057,-92.847,-239.59,-92.506C-239.59,-92.506,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-125.605,-155.254,-125.605,-155.254C-125.605,-155.254,-115.245,-160.605,-115.245,-160.605C-85.996,-172.8,-69.868,-160.475,-63.34,-147.582C-26.996,-75.8,-127.496,-34.3,-98.838,0.077C-85.723,15.809,-63.188,-7.508,17.053,-23.624C130.032,-46.313,84.769,7.515,160.807,50.903C191.751,72.351,242.189,96.167,268.526,81.355Z; M278.526,62.355C263.401,93.466,245.257,118.924,225.754,128.71C173.504,165.7,28.449,157.301,-13.125,112.735C-105.496,43.7,-210.188,94.467,-235.493,56.65C-268.525,7.284,-178.246,-39.3,-215.003,-82.63C-219.369,-87.776,-221.12,-86.8,-225.965,-89.006C-225.965,-89.006,-179.616,-116.591,-179.616,-116.591C-179.616,-116.591,-110.105,-158.254,-110.105,-158.254C-110.105,-158.254,-99.745,-163.605,-99.745,-163.605C-92.691,-165.007,-86.609,-165.75,-76.339,-155.582C-19.495,-99.3,-128.917,-24.853,-117.838,5.577C-98.496,58.7,-59.132,23.1,10.053,-20.624C66.504,-56.3,87.768,-7.485,163.806,35.903C194.75,57.351,252.189,77.167,278.526,62.355Z; M278.526,52.355C263.401,83.466,245.257,118.924,225.754,128.71C143.504,191.7,28.449,157.301,-13.125,112.735C-98.496,33.7,-210.188,94.467,-235.493,56.65C-268.525,7.284,-153.059,-37.01,-215.003,-82.63C-225.139,-90.093,-233.057,-92.847,-239.59,-92.506C-239.59,-92.506,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-103.745,-165.105,-103.745,-165.105C-96.691,-166.507,-87.975,-164.153,-76.339,-155.582C-14.39,-109.96,-155.876,-40.796,-122.838,8.577C-107.456,31.566,-71.784,-19.569,10.053,-20.624C62.504,-21.3,87.768,-7.485,163.806,35.903C194.75,57.351,252.189,67.167,278.526,52.355Z; M268.525,62.355C253.4,93.466,234.004,116.7,216.754,130.71C156.504,175.7,45.449,166.301,3.875,121.735C-108.162,4.094,-225.062,100.941,-235.493,56.65C-251.495,-11.3,-194.996,-62.8,-215.003,-82.63C-223.943,-91.491,-245.057,-87.347,-251.59,-87.006C-251.59,-87.006,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-102.745,-162.105,-102.745,-162.105C-95.691,-163.507,-81.188,-156.008,-72.339,-144.582C-24.495,-82.8,-143.996,-42.3,-122.838,8.577C-112.217,34.117,-62.188,3.492,18.053,-12.624C131.032,-35.313,125.768,22.515,201.806,65.903C232.75,87.351,242.188,77.167,268.525,62.355Z; M268.525,62.355C253.4,93.466,234.004,116.7,216.754,130.71C156.504,175.7,45.449,166.301,3.875,121.735C-108.162,4.094,-225.062,100.941,-235.493,56.65C-251.495,-11.3,-194.996,-62.8,-215.003,-82.63C-223.943,-91.491,-245.057,-87.347,-251.59,-87.006C-251.59,-87.006,-185.116,-123.091,-185.116,-123.091C-185.116,-123.091,-114.104,-159.754,-114.104,-159.754C-114.104,-159.754,-102.745,-162.105,-102.745,-162.105C-95.691,-163.507,-81.188,-156.008,-72.339,-144.582C-24.495,-82.8,-143.996,-42.3,-122.838,8.577C-112.217,34.117,-62.188,3.492,18.053,-12.624C131.032,-35.313,125.768,22.515,201.806,65.903C232.75,87.351,242.188,77.167,268.525,62.355Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,537.555,739.273)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc4cc",
    d: "M-74.403,9.266C-74.403,9.266,30.088,-52.255,30.088,-52.255C30.088,-52.255,74.403,-35.019,61.359,-6.172C14.041,23.042,-51.382,52.255,-51.382,52.255C-51.382,52.255,-56.167,15.438,-74.403,9.266Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,445.728,647.731)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M82.83,-39.22C20.719,-6.868,4.951,51.549,38.652,72.477C38.652,72.477,-22.322,106.812,-22.322,106.812C-35.228,112.518,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-124.962,69.736,-55.833,33.73C-12.856,11.342,-8.608,-35.387,-42.662,-60.287C-51.28,-66.59,-55.998,-68.737,-68.627,-70.849C-80.072,-72.765,-90.083,-73.044,-99.618,-70.574C-99.618,-70.574,8.246,-141.486,8.246,-141.486C8.246,-141.486,8.494,-141.624,8.494,-141.624C22.347,-149.191,40.602,-151.054,60.037,-147.799C122.598,-137.317,136.687,-67.271,82.83,-39.22Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M82.83,-39.22C20.719,-6.868,4.951,51.549,38.652,72.477C38.652,72.477,-22.322,106.812,-22.322,106.812C-35.228,112.518,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-124.962,69.736,-55.833,33.73C-12.856,11.342,-8.608,-35.387,-42.662,-60.287C-51.28,-66.59,-55.998,-68.737,-68.627,-70.849C-80.072,-72.765,-90.083,-73.044,-99.618,-70.574C-99.618,-70.574,8.246,-141.486,8.246,-141.486C8.246,-141.486,8.494,-141.624,8.494,-141.624C22.347,-149.191,40.602,-151.054,60.037,-147.799C122.598,-137.317,136.687,-67.271,82.83,-39.22Z; M77.83,-25.22C17.446,10.251,26.95,40.05,60.651,60.978C60.651,60.978,-15.822,103.062,-15.822,103.062C-38.228,103.768,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-132.462,66.237,-63.333,30.231C-20.356,7.843,-14.108,-39.386,-48.162,-64.286C-56.78,-70.589,-67.498,-75.236,-80.127,-77.348C-91.572,-79.264,-102.083,-78.543,-111.618,-76.073C-111.618,-76.073,8.246,-141.486,8.246,-141.486C8.246,-141.486,24.994,-150.124,24.994,-150.124C38.847,-157.691,51.771,-155.731,68.036,-146.299C127.242,-111.965,129.772,-55.732,77.83,-25.22Z; M75.33,-28.72C16.187,8.784,2.771,60.268,57.151,70.977C57.151,70.977,-2.322,106.562,-2.322,106.562C-16.728,106.268,-42.418,143.437,-61.875,154.883C-68.166,158.589,-78.728,162.768,-88.195,155.992C-130.191,125.933,-132.462,66.236,-63.333,30.23C-20.356,7.842,-5.108,-39.886,-39.162,-64.786C-47.78,-71.089,-57.998,-77.237,-70.627,-79.349C-82.072,-81.265,-102.083,-78.543,-111.618,-76.073C-111.618,-76.073,15.246,-142.986,15.246,-142.986C15.246,-142.986,15.494,-143.624,15.494,-143.624C29.347,-151.191,48.67,-149.986,67.537,-144.299C135.772,-123.731,114.772,-53.732,75.33,-28.72Z; M75.33,-28.72C13.823,4.765,31.771,67.269,54.651,63.978C54.651,63.978,-15.822,103.062,-15.822,103.062C-38.228,103.768,-43.419,136.937,-62.876,148.383C-69.167,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-132.462,66.236,-63.333,30.23C-20.356,7.842,-1.108,-31.886,-35.162,-56.786C-43.78,-63.089,-51.998,-65.237,-64.627,-67.349C-76.072,-69.265,-103.083,-69.543,-112.618,-67.073C-112.618,-67.073,11.246,-137.986,11.246,-137.986C11.246,-137.986,5.494,-134.624,5.494,-134.624C19.347,-142.191,48.67,-146.986,67.537,-141.299C135.772,-120.731,121.272,-53.732,75.33,-28.72Z; M82.83,-39.22C20.719,-6.868,4.951,51.549,38.652,72.477C38.652,72.477,-22.322,106.812,-22.322,106.812C-35.228,112.518,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-124.962,69.736,-55.833,33.73C-12.856,11.342,-8.608,-35.386,-42.662,-60.286C-51.28,-66.589,-55.998,-68.737,-68.627,-70.849C-80.072,-72.765,-90.083,-73.044,-99.618,-70.574C-99.618,-70.574,8.246,-141.486,8.246,-141.486C8.246,-141.486,8.494,-141.624,8.494,-141.624C22.347,-149.191,40.602,-151.054,60.037,-147.799C122.598,-137.317,136.687,-67.271,82.83,-39.22Z; M82.83,-39.22C20.719,-6.868,4.951,51.549,38.652,72.477C38.652,72.477,-22.322,106.812,-22.322,106.812C-35.228,112.518,-43.418,136.937,-62.875,148.383C-69.166,152.089,-76.802,153.554,-86.695,150.992C-136.686,138.028,-124.962,69.736,-55.833,33.73C-12.856,11.342,-8.608,-35.386,-42.662,-60.286C-51.28,-66.589,-55.998,-68.737,-68.627,-70.849C-80.072,-72.765,-90.083,-73.044,-99.618,-70.574C-99.618,-70.574,8.246,-141.486,8.246,-141.486C8.246,-141.486,8.494,-141.624,8.494,-141.624C22.347,-149.191,40.602,-151.054,60.037,-147.799C122.598,-137.317,136.687,-67.271,82.83,-39.22Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,485.488,582.028)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ccc4cc",
    d: "M-50.137,64.258C0.061,38.029,68.44,-11.041,68.44,-11.041C68.44,-11.041,72.828,-54.656,36.62,-64.257C-6.446,-43.409,-72.828,-4.492,-72.828,-4.492C-72.828,-4.492,-35.873,22.734,-50.137,64.258Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,418.673,773.283)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6584c6",
    d: "M36.57,-12.113C36.57,-12.113,-35.82,22.831,-35.82,22.831C-16.364,11.386,-4.298,-21.658,11.357,-19.739C18.401,-18.876,30.577,-18.908,36.57,-12.113Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M36.57,-12.113C36.57,-12.113,-35.82,22.831,-35.82,22.831C-16.364,11.386,-4.298,-21.658,11.357,-19.739C18.401,-18.876,30.577,-18.908,36.57,-12.113Z; M35.82,-12.613C35.82,-12.613,-35.82,22.831,-35.82,22.831C-16.364,11.386,-8.548,-24.658,11.232,-22.489C17.735,-21.776,25.685,-20.076,35.82,-12.613Z; M39.945,-6.113C39.945,-6.113,-29.57,25.706,-29.57,25.706C-10.114,14.261,4.077,-18.283,25.732,-18.864C32.272,-19.039,33.202,-17.783,39.945,-6.113Z; M35.32,-12.863C35.32,-12.863,-35.695,22.956,-35.695,22.956C-16.239,11.511,-10.423,-22.283,11.482,-22.489C18.024,-22.551,24.952,-20.408,35.32,-12.863Z; M36.57,-12.113C36.57,-12.113,-35.82,22.831,-35.82,22.831C-16.364,11.386,-4.298,-21.658,11.357,-19.739C18.401,-18.876,30.577,-18.908,36.57,-12.113Z; M36.57,-12.113C36.57,-12.113,-35.82,22.831,-35.82,22.831C-16.364,11.386,-4.298,-21.658,11.357,-19.739C18.401,-18.876,30.577,-18.908,36.57,-12.113Z",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994444; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,504.827,820.32)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-43.34,20.309C-43.34,20.309,43.341,-20.309,43.341,-20.309"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,490.201,850.064)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-45.348,21.231C-45.348,21.231,45.348,-21.231,45.348,-21.231"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,448.032,655.67)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-37.319,19.823C-37.319,19.823,37.319,-19.823,37.319,-19.823"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,414.027,691.718)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-49.125,23.628C-49.125,23.628,49.125,-23.628,49.125,-23.628"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,406.203,741.663)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-57.193,29.419C-57.193,29.419,57.193,-29.419,57.193,-29.419"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,389.407,780.282)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-16.796,11.247C-16.796,11.247,16.796,-11.247,16.796,-11.247"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,400.797,722.197)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M53.697,-26.128C53.697,-26.128,-53.697,26.128,-53.697,26.128"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,439.542,532.857)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-45.809,25.51C-45.809,25.51,45.809,-25.51,45.809,-25.51"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,515.394,871.295)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1,
    stroke: "#000000",
    d: "M-25.193,11.795C-25.193,11.795,25.193,-11.795,25.193,-11.795"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(600.27,534.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-10)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-10; 0; 5; -10; 5; 0; -10; -10",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-600.27,-534.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,617.843,516.673)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#1a1a1a",
    fill: "#1a1a1a",
    d: "M5.758,-10.492C5.758,-10.492,8.844,6.789,5.758,8.641C2.672,10.492,-8.845,7.406,-8.64,6.378C-8.437,5.349,-5.977,-8.64,-5.977,-8.64C-5.977,-8.64,5.758,-10.492,5.758,-10.492Z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(624.973,524.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-13)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-13; 3; 0; 3; 0; 3; -13; -13",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-624.973,-524.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,661.98,579.439)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M29.98,20.477C25.5,21.301,20.554,22.937,10.296,27.04C-18.783,34.775,15.144,-40.297,-34.074,-55.43C-34.074,-55.43,-37.007,50.959,-37.007,50.959C-4.622,55.43,24.135,35.873,30.747,34.56C34.813,33.752,37.008,20.357,29.98,20.477Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,658.473,598.45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M-18.131,-40.632C-18.131,-40.632,-9.978,-26.025,-5.657,-3.601C-1.337,18.824,28.288,18.825,28.288,18.825C28.288,18.825,14.093,37.752,11.829,39.193C9.566,40.632,-11.332,37.396,-11.332,37.396C-11.332,37.396,-27.465,-1.006,-27.876,-2.406C-28.288,-3.805,-18.131,-40.632,-18.131,-40.632Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,699.208,613.547)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc9590",
    d: "M-6.789,-12.216C-6.789,-12.216,7.097,-11.394,9.978,-6.765C12.857,-2.136,12.344,8.048,12.344,8.048C12.344,8.048,7.798,12.216,2.057,8.768C-3.685,5.32,-3.909,-1.519,-7.921,-1.93C-12.858,-5.633,-9.875,-11.29,-6.789,-12.216Z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(635.519,657.221)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -3; 0; -3; 0; 0",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-635.519,-657.221)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(689.64,868.104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(11)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "11; 0; 11; 0; 11; 11",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-689.64,-868.104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,673.963,916.24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M6.263,-34.309C5.708,-33.693,-4.29,-37.861,-11.455,-29.075C-18.62,-20.288,-1.286,37.861,8.651,37.143C18.586,36.425,18.332,9.254,18.477,-6.594C18.62,-22.443,6.263,-34.309,6.263,-34.309Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,685.656,881.669)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#572658",
    d: "M10.47,-6.049C10.47,-6.049,2.678,16.85,2.678,16.85C2.678,16.85,-10.44,12.847,-10.47,1.114C-3.911,-15.463,-3.593,-16.849,-3.593,-16.849C-3.593,-16.849,9.546,-12.454,10.47,-6.049Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,690.669,920.383)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.47,
    stroke: "#ffcf4a",
    d: "M5.457,-19.545C5.457,-19.545,-15.635,-17.623,-10.286,-12.412C-4.937,-7.2,20.985,-13.784,8.367,-7.749C-4.251,-1.715,-20.984,-4.32,-10.148,-1.441C0.686,1.439,16.87,1.577,9.602,5.829C2.332,10.08,-13.441,9.394,-6.995,12.138C-0.549,14.881,4.526,19.544,4.526,19.544"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,698.519,770.309)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M78.217,-38.966C74.113,5.564,-0.881,125.088,-0.881,125.088C-8.574,124.435,-15.345,117.59,-21.307,105.302C-22.133,103.605,-22.94,101.799,-23.737,99.893C-23.737,99.893,20.799,-17.87,13.18,-42.481C8.585,-57.338,-25.272,-75.612,-51.379,-87.761C-68.515,-95.733,-82.316,-101.071,-82.316,-101.071C-82.316,-101.071,-44.233,-125.088,-44.233,-125.088C-44.233,-125.088,82.316,-83.49,78.217,-38.966Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,700.539,769.697)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M-23.327,105.914C-24.152,104.218,-24.961,102.41,-25.758,100.505C-25.758,100.505,18.779,-17.258,11.16,-41.868C6.566,-56.726,-27.292,-74.999,-53.398,-87.148C-53.398,-87.148,-53.398,-101.607,-53.398,-101.607C-53.398,-101.607,-35.125,-105.913,-35.125,-105.913C-17.561,-102.429,14.617,-84.897,34.362,-53.856C53.399,-23.935,-17.209,97.193,-23.327,105.914Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,768.984,731.231)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#ffffff",
    d: "M1.535,-9.002C1.535,-9.002,-4.389,-0.05,-4.389,-0.05C-4.389,-0.05,4.389,-0.05,4.389,-0.05C4.389,-0.05,-3.017,6.533,-3.017,6.533C-3.017,6.533,1.535,9.002,1.535,9.002"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(602,651)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 3; 0; 3; 0; 0",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-602,-651)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(774.397,888.573)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 8; 0; 8; 0; 0",
    keyTimes: "0; 0.248611; 0.497222; 0.745833; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-774.397,-888.573)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,793.128,938.031)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M-17.68,-32.376C-17.812,-31.558,-28.473,-29.645,-29.737,-18.378C-30.999,-7.111,15.073,32.376,23.036,26.39C30.999,20.403,16.065,-2.296,7.6,-15.696C-0.864,-29.096,-17.68,-32.376,-17.68,-32.376Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,779.487,902.9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#572658",
    d: "M5.908,-11.164C5.908,-11.164,11.763,12.306,11.763,12.306C11.763,12.306,-1.432,16.047,-7.813,6.201C-11.279,-11.286,-11.763,-12.623,-11.763,-12.623C-11.763,-12.623,1.662,-16.047,5.908,-11.164Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,796.892,929.041)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.47,
    stroke: "#ffcf4a",
    d: "M3.844,-18.43C3.844,-18.43,-21.05,-3.994,-9.529,-4.818C1.992,-5.64,14.997,-13.573,11.478,-6.874C7.958,-0.177,-3.974,6.087,3.638,7.321C11.25,8.555,21.051,1.276,18.45,7.321C15.85,13.365,-1.415,15.49,8.369,16.784C18.155,18.079,18.878,18.43,18.878,18.43"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,673.325,775.503)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M119.227,114.035C118.753,116.003,117.847,117.625,116.6,118.953C110.211,125.861,95.014,124.891,85.957,123.558C81.704,122.935,78.8,122.237,78.8,122.237C78.8,122.237,42.478,-34.198,-38.375,-48.847C-119.227,-63.49,-117.616,-107.004,-117.616,-107.004C-117.616,-107.004,-111.463,-112.852,-98.061,-117.29C-82.154,-122.566,-56.03,-125.861,-17.867,-115.05C8.545,-107.524,29.71,-91.426,46.813,-70.797C46.813,-70.797,46.819,-70.792,46.819,-70.792C46.819,-70.786,46.819,-70.78,46.825,-70.775C92.295,-15.902,109.01,71.035,119.227,114.035Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,756.351,799.592)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M36.201,89.946C35.727,91.914,34.821,93.536,33.574,94.864C31.053,89.138,29.585,79.662,26.487,65.225C7.015,-25.502,-35.295,-92.895,-36.201,-94.864C9.269,-39.991,25.984,46.946,36.201,89.946Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,656.69,778.637)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M102.592,120.424C98.338,119.801,95.435,119.103,95.435,119.103C95.435,119.103,59.113,-37.333,-21.74,-51.981C-102.592,-66.625,-100.982,-110.138,-100.982,-110.138C-100.982,-110.138,-94.829,-115.985,-81.426,-120.424C-70.697,-99.182,-46.679,-68.172,4.13,-58.908C71.696,-46.591,96.595,81.793,102.592,120.424Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,731.018,744.388)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.94,
    stroke: "#ffffff",
    d: "M-0.163,-9.011C-0.163,-9.011,-8.066,4.392,-8.066,4.392C-8.066,4.392,5.872,-0.864,5.872,-0.864C5.872,-0.864,1.208,9.011,1.208,9.011C1.208,9.011,8.066,9.011,8.066,9.011"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,610.195,595.384)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde70",
    d: "M59.029,49.837C51.705,77.369,-57.367,76.497,-57.367,76.497C-57.367,76.497,-59.029,19.31,-55.768,-21.122C-55.237,-27.708,-54.574,-33.849,-53.754,-39.223C-48.859,-71.303,-23.872,-72.619,-23.872,-72.619C-1.575,-77.369,13.922,-75.309,24.968,-68.111C34.381,-53.513,40.409,-35.759,39.831,-11.841C39.162,0.228,39.861,9.146,41.529,16.378C44.744,30.316,51.549,37.97,59.029,49.837Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,610.195,623.507)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M59.029,21.714C51.705,49.246,-57.367,48.374,-57.367,48.374C-57.367,48.374,-59.029,-8.813,-55.768,-49.245C-43.243,-36.922,-21.068,-19.243,3.122,-19.191C24.674,-19.145,35.901,-15.116,41.529,-11.745C44.744,2.193,51.549,9.847,59.029,21.714Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,604.076,558.336)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M5.124,18.616C6.808,13.782,4.404,-9.26,2.964,-20.616C-0.944,-17.324,-6.808,-17.284,-6.808,-17.284C-6.808,-17.284,-6.294,-15.432,-6.294,-15.432C-6.294,-15.432,0.187,-14.918,1.729,-17.489C2.759,-9.363,3.787,19.199,3.787,19.199C3.787,19.199,4.427,20.616,5.124,18.616Z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(624.973,524.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-13)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-13; 3; 0; 3; 0; 3; -13; -13",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-624.973,-524.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,695.873,649.067)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M-22.501,14.717C-22.501,14.717,22.502,-14.717,22.502,-14.717C22.502,-14.717,20.171,-14.717,20.171,-14.717C20.171,-14.717,-19.295,8.171,-19.295,8.171C-19.295,8.171,-22.501,14.717,-22.501,14.717Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,647.14,652.161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M-27.053,-11.624C-27.053,-11.624,29.727,5.531,29.727,5.531C29.727,5.531,26.231,11.623,26.231,11.623C26.231,11.623,-29.727,-6.942,-29.727,-6.942C-29.727,-6.942,-27.053,-11.624,-27.053,-11.624Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,671.519,635.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b546b",
    d: "M10.287,-21.847C8.435,-21.436,-51.432,4.692,-51.432,4.692C-51.432,4.692,5.35,21.847,5.35,21.847C5.35,21.847,51.433,-7.241,51.433,-7.241C51.433,-7.241,10.287,-21.847,10.287,-21.847Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,703.167,628.958)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M23.694,-30.596C23.694,-30.596,-26.59,28.281,-26.59,28.281C-26.59,28.281,-22.862,30.596,-22.862,30.596C-22.862,30.596,26.59,-27.626,26.59,-27.626C26.59,-27.626,23.694,-30.596,23.694,-30.596Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,752.529,585.743)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152a52",
    d: "M23.837,-15.589C23.837,-15.589,-25.668,12.62,-25.668,12.62C-25.668,12.62,-22.771,15.589,-22.771,15.589C-22.771,15.589,25.668,-12.699,25.668,-12.699C25.668,-12.699,23.837,-15.589,23.837,-15.589Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,729.252,616.298)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b546b",
    d: "M-48.946,43.255C-48.946,43.255,2.547,12.567,2.547,12.567C2.547,12.567,48.946,-43.255,48.946,-43.255C48.946,-43.255,0.506,-14.967,0.506,-14.967C0.506,-14.967,-48.946,43.255,-48.946,43.255Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,728.646,618.093)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf4a",
    d: "M2.372,-5.588C2.372,-5.588,-2.373,1.445,-2.373,1.445C-2.373,1.445,-2.373,5.588,-2.373,5.588C-2.373,5.588,2.372,0,2.372,0C2.372,0,2.372,-5.588,2.372,-5.588Z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.843,526.984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-19)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-19; 0; 11; 0; 11; 0; -19; -19",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-576.843,-526.984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,574.074,597.02)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffde70",
    d: "M41.964,40.619C25.964,49.542,-25.848,64.025,-41.08,10.717C-52.832,-30.402,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-13.081,-23.584,-13.081,-23.584C-22.98,18.36,10.894,38.218,29.168,30.91C32.469,29.589,35.263,28.504,37.704,27.598C42.368,27.511,45.155,30.414,45.635,33.623C46.027,36.238,44.879,39.06,41.964,40.619Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M41.964,40.619C25.964,49.542,-25.848,64.025,-41.08,10.717C-52.832,-30.402,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-13.081,-23.584,-13.081,-23.584C-22.98,18.36,10.894,38.218,29.168,30.91C32.469,29.589,35.263,28.504,37.704,27.598C42.368,27.511,45.155,30.414,45.635,33.623C46.027,36.238,44.879,39.06,41.964,40.619Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-16.836,-19.589,-16.836,-19.589C-26.735,22.355,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M47.512,30.856C29.926,40.23,-28.574,70.48,-44.01,19.227C-56.342,-21.722,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.884,-23.307,-8.884,-23.307C-43.045,28.419,19.379,26.143,37.653,18.835C40.954,17.514,44.248,15.929,46.689,15.023C51.353,14.936,52.772,17.918,53.995,20.923C56.613,27.355,50.676,29.48,47.512,30.856Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.138,-23.317,-8.138,-23.317C-27.04,22.111,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M47.512,30.856C29.926,40.23,-28.574,70.48,-44.01,19.227C-56.342,-21.722,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.884,-23.307,-8.884,-23.307C-43.045,28.419,19.379,26.143,37.653,18.835C40.954,17.514,44.248,15.929,46.689,15.023C51.353,14.936,52.772,17.918,53.995,20.923C56.613,27.355,50.676,29.48,47.512,30.856Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-16.836,-19.589,-16.836,-19.589C-26.735,22.355,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M47.512,30.856C29.926,40.23,-28.574,70.48,-44.01,19.227C-56.342,-21.722,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.884,-23.307,-8.884,-23.307C-43.045,28.419,19.379,26.143,37.653,18.835C40.954,17.514,44.248,15.929,46.689,15.023C51.353,14.936,52.772,17.918,53.995,20.923C56.613,27.355,50.676,29.48,47.512,30.856Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.138,-23.317,-8.138,-23.317C-27.04,22.111,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M47.512,30.856C29.926,40.23,-28.574,70.48,-44.01,19.227C-56.342,-21.722,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-8.884,-23.307,-8.884,-23.307C-43.045,28.419,19.379,26.143,37.653,18.835C40.954,17.514,44.248,15.929,46.689,15.023C51.353,14.936,52.772,17.918,53.995,20.923C56.613,27.355,50.676,29.48,47.512,30.856Z; M51.699,31.544C35.699,40.467,-28.778,72.535,-44.01,19.227C-55.762,-21.892,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-16.836,-19.589,-16.836,-19.589C-26.735,22.355,20.629,29.143,38.903,21.835C42.204,20.514,44.998,19.429,47.439,18.523C52.103,18.436,54.89,21.339,55.37,24.548C55.762,27.163,54.614,29.985,51.699,31.544Z; M41.964,40.619C25.964,49.542,-25.848,64.025,-41.08,10.717C-52.832,-30.402,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-13.081,-23.584,-13.081,-23.584C-22.98,18.36,10.894,38.218,29.168,30.91C32.469,29.589,35.263,28.504,37.704,27.598C42.368,27.511,45.155,30.414,45.635,33.623C46.027,36.238,44.879,39.06,41.964,40.619Z; M41.964,40.619C25.964,49.542,-25.848,64.025,-41.08,10.717C-52.832,-30.402,-37.465,-46.151,-19.97,-59.3C-7.238,-68.858,5.074,-72.535,5.074,-72.535C5.074,-72.535,-13.081,-23.584,-13.081,-23.584C-22.98,18.36,10.894,38.218,29.168,30.91C32.469,29.589,35.263,28.504,37.704,27.598C42.368,27.511,45.155,30.414,45.635,33.623C46.027,36.238,44.879,39.06,41.964,40.619Z",
    keyTimes: "0; 0.166667; 0.255555; 0.333334; 0.422222; 0.5; 0.588889; 0.666667; 0.755556; 0.833334; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,574.074,603.637)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb114",
    d: "M41.964,34.002C25.964,42.925,-25.701,58.516,-40.933,5.208C-52.685,-35.911,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-41.258,-29.009,-31.758,2.263C-18.447,46.072,30.57,34.331,45.635,27.006C46.027,29.621,44.879,32.443,41.964,34.002Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M41.964,34.002C25.964,42.925,-25.701,58.516,-40.933,5.208C-52.685,-35.911,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-41.258,-29.009,-31.758,2.263C-18.447,46.072,30.57,34.331,45.635,27.006C46.027,29.621,44.879,32.443,41.964,34.002Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M47.324,24.302C27.551,34.114,-28.699,63.363,-44.01,12.61C-56.361,-28.333,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,38.867,21.443,53.932,14.118C56.738,20.238,51.488,22.801,47.324,24.302Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M47.324,24.302C27.551,34.114,-28.699,63.363,-44.01,12.61C-56.361,-28.333,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,38.867,21.443,53.932,14.118C56.738,20.238,51.488,22.801,47.324,24.302Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M47.324,24.302C27.551,34.114,-28.699,63.363,-44.01,12.61C-56.361,-28.333,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,38.867,21.443,53.932,14.118C56.738,20.238,51.488,22.801,47.324,24.302Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M47.324,24.302C27.551,34.114,-28.699,63.363,-44.01,12.61C-56.361,-28.333,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,38.867,21.443,53.932,14.118C56.738,20.238,51.488,22.801,47.324,24.302Z; M51.699,24.927C35.699,33.85,-28.778,65.918,-44.01,12.61C-55.762,-28.509,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-46.071,-21.941,-36.571,9.331C-23.26,53.14,40.305,25.256,55.37,17.931C55.762,20.546,54.614,23.368,51.699,24.927Z; M41.964,34.002C25.964,42.925,-25.701,58.516,-40.933,5.208C-52.685,-35.911,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-41.258,-29.009,-31.758,2.263C-18.447,46.072,30.57,34.331,45.635,27.006C46.027,29.621,44.879,32.443,41.964,34.002Z; M41.964,34.002C25.964,42.925,-25.701,58.516,-40.933,5.208C-52.685,-35.911,-37.465,-52.768,-19.97,-65.917C-31.854,-49.64,-41.258,-29.009,-31.758,2.263C-18.447,46.072,30.57,34.331,45.635,27.006C46.027,29.621,44.879,32.443,41.964,34.002Z",
    keyTimes: "0; 0.166667; 0.255555; 0.333334; 0.422222; 0.5; 0.588889; 0.666667; 0.755556; 0.833334; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(622.094,623.184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -24; 0; -24; 0; -24; 0; -24; 0; -24; 0; 0",
    keyTimes: "0; 0.166667; 0.255555; 0.333334; 0.422222; 0.5; 0.588889; 0.666667; 0.755556; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.115,2.886)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc9590",
    d: "M-25.679,0.28C-25.679,0.28,-9.838,-5.377,-1.609,-1.674C6.62,2.029,8.986,22.191,8.986,22.191C8.986,22.191,8.471,23.528,6.209,22.191C3.946,20.853,0.448,8.98,0.448,8.98C0.448,8.98,-0.786,15.299,-6.033,16.739C-11.279,18.179,-17.034,13.858,-18.425,12.213C-19.816,10.567,-25.679,9.926,-25.679,9.926C-25.679,9.926,-28.456,4.6,-25.679,0.28Z"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "M-25.679,0.28C-25.679,0.28,-9.838,-5.377,-1.609,-1.674C6.62,2.029,8.986,22.191,8.986,22.191C8.986,22.191,8.471,23.528,6.209,22.191C3.946,20.853,0.448,8.98,0.448,8.98C0.448,8.98,-0.786,15.299,-6.033,16.739C-11.279,18.179,-17.034,13.858,-18.425,12.213C-19.816,10.567,-25.679,9.926,-25.679,9.926C-25.679,9.926,-28.456,4.6,-25.679,0.28Z; M-15.944,-8.796C-15.944,-8.796,-0.103,-14.453,8.126,-10.75C16.355,-7.047,18.721,13.115,18.721,13.115C18.721,13.115,18.206,14.452,15.944,13.115C13.681,11.777,10.183,-0.096,10.183,-0.096C10.183,-0.096,8.949,6.224,3.702,7.664C-1.544,9.104,-7.299,4.783,-8.69,3.138C-10.081,1.492,-15.944,0.851,-15.944,0.851C-15.944,0.851,-18.721,-4.476,-15.944,-8.796Z; M-16.944,-13.296C-16.944,-13.296,-1.103,-18.953,7.126,-15.25C15.355,-11.547,17.721,8.615,17.721,8.615C17.721,8.615,17.206,9.952,14.944,8.615C12.681,7.277,9.183,-4.596,9.183,-4.596C9.183,-4.596,7.949,1.724,2.702,3.164C-2.544,4.604,-8.299,0.283,-9.69,-1.362C-11.081,-3.008,-16.944,-3.649,-16.944,-3.649C-16.944,-3.649,-19.721,-8.976,-16.944,-13.296Z; M-16.477,-8.212C-16.477,-8.212,-0.636,-13.869,7.593,-10.166C15.822,-6.463,18.188,13.699,18.188,13.699C18.188,13.699,17.673,15.036,15.411,13.699C13.148,12.361,9.65,0.488,9.65,0.488C9.65,0.488,8.416,6.807,3.169,8.247C-2.077,9.687,-7.832,5.366,-9.223,3.721C-10.614,2.075,-16.477,1.434,-16.477,1.434C-16.477,1.434,-19.254,-3.892,-16.477,-8.212Z; M-16.944,-13.296C-16.944,-13.296,-1.103,-18.953,7.126,-15.25C15.355,-11.547,17.721,8.615,17.721,8.615C17.721,8.615,17.206,9.952,14.944,8.615C12.681,7.277,9.183,-4.596,9.183,-4.596C9.183,-4.596,7.949,1.724,2.702,3.164C-2.544,4.604,-8.299,0.283,-9.69,-1.362C-11.081,-3.008,-16.944,-3.649,-16.944,-3.649C-16.944,-3.649,-19.721,-8.976,-16.944,-13.296Z; M-16.477,-8.212C-16.477,-8.212,-0.636,-13.869,7.593,-10.166C15.822,-6.463,18.188,13.699,18.188,13.699C18.188,13.699,17.673,15.036,15.411,13.699C13.148,12.361,9.65,0.488,9.65,0.488C9.65,0.488,8.416,6.807,3.169,8.247C-2.077,9.687,-7.832,5.366,-9.223,3.721C-10.614,2.075,-16.477,1.434,-16.477,1.434C-16.477,1.434,-19.254,-3.892,-16.477,-8.212Z; M-16.944,-13.296C-16.944,-13.296,-1.103,-18.953,7.126,-15.25C15.355,-11.547,17.721,8.615,17.721,8.615C17.721,8.615,17.206,9.952,14.944,8.615C12.681,7.277,9.183,-4.596,9.183,-4.596C9.183,-4.596,7.949,1.724,2.702,3.164C-2.544,4.604,-8.299,0.283,-9.69,-1.362C-11.081,-3.008,-16.944,-3.649,-16.944,-3.649C-16.944,-3.649,-19.721,-8.976,-16.944,-13.296Z; M-16.477,-8.212C-16.477,-8.212,-0.636,-13.869,7.593,-10.166C15.822,-6.463,18.188,13.699,18.188,13.699C18.188,13.699,17.673,15.036,15.411,13.699C13.148,12.361,9.65,0.488,9.65,0.488C9.65,0.488,8.416,6.807,3.169,8.247C-2.077,9.687,-7.832,5.366,-9.223,3.721C-10.614,2.075,-16.477,1.434,-16.477,1.434C-16.477,1.434,-19.254,-3.892,-16.477,-8.212Z; M-16.944,-13.296C-16.944,-13.296,-1.103,-18.953,7.126,-15.25C15.355,-11.547,17.721,8.615,17.721,8.615C17.721,8.615,17.206,9.952,14.944,8.615C12.681,7.277,9.183,-4.596,9.183,-4.596C9.183,-4.596,7.949,1.724,2.702,3.164C-2.544,4.604,-8.299,0.283,-9.69,-1.362C-11.081,-3.008,-16.944,-3.649,-16.944,-3.649C-16.944,-3.649,-19.721,-8.976,-16.944,-13.296Z; M-16.477,-8.212C-16.477,-8.212,-0.636,-13.869,7.593,-10.166C15.822,-6.463,18.188,13.699,18.188,13.699C18.188,13.699,17.673,15.036,15.411,13.699C13.148,12.361,9.65,0.488,9.65,0.488C9.65,0.488,8.416,6.807,3.169,8.247C-2.077,9.687,-7.832,5.366,-9.223,3.721C-10.614,2.075,-16.477,1.434,-16.477,1.434C-16.477,1.434,-19.254,-3.892,-16.477,-8.212Z; M-25.679,0.28C-25.679,0.28,-9.838,-5.377,-1.609,-1.674C6.62,2.029,8.986,22.191,8.986,22.191C8.986,22.191,8.471,23.528,6.209,22.191C3.946,20.853,0.448,8.98,0.448,8.98C0.448,8.98,-0.786,15.299,-6.033,16.739C-11.279,18.179,-17.034,13.858,-18.425,12.213C-19.816,10.567,-25.679,9.926,-25.679,9.926C-25.679,9.926,-28.456,4.6,-25.679,0.28Z; M-25.679,0.28C-25.679,0.28,-9.838,-5.377,-1.609,-1.674C6.62,2.029,8.986,22.191,8.986,22.191C8.986,22.191,8.471,23.528,6.209,22.191C3.946,20.853,0.448,8.98,0.448,8.98C0.448,8.98,-0.786,15.299,-6.033,16.739C-11.279,18.179,-17.034,13.858,-18.425,12.213C-19.816,10.567,-25.679,9.926,-25.679,9.926C-25.679,9.926,-28.456,4.6,-25.679,0.28Z",
    keyTimes: "0; 0.166667; 0.255555; 0.333334; 0.422222; 0.5; 0.588889; 0.666667; 0.755556; 0.833334; 0.994444; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  })))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(610.814,671.884)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-7; 0; 4; 0; 4; 0; -7; -7",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.833 1; 0.167 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-610.814,-671.884)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(600.27,534.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-10)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6s",
    begin: "0s",
    calcMode: "spline",
    values: "-10; 0; 5; -10; 5; 0; -10; -10",
    keyTimes: "0; 0.166667; 0.333334; 0.5; 0.666667; 0.833334; 0.994445; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-600.27,-534.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,611.045,493.766)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fc9590",
    d: "M1.055,36.032C1.055,36.032,2.301,17.669,2.301,17.669C2.301,17.669,28.467,26.54,29.289,-16.593C29.789,-42.765,6.621,-49.215,-6.854,-35.447C-20.33,-21.678,-12.6,1.757,-15.879,11.718C-18.053,18.322,-25.619,27.838,-28.383,33.708C-29.788,36.691,-7.733,49.215,1.055,36.032Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,611.488,481.163)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M-43.283,47.879C-43.283,47.879,-30.273,43.941,-22.86,42.572C-5.853,38.527,-8.185,20.697,-9.282,8.079C-10.379,-4.539,-5.442,-7.282,-3.247,-5.911C-1.053,-4.539,6.457,-7.008,8.599,-12.22C22.263,-11.945,21.155,0.864,32.178,3.058C32.178,3.058,44.38,-14.414,35.653,-26.483C26.926,-38.553,14.308,-34.164,14.308,-34.164C14.308,-34.164,-1.327,-47.879,-18.06,-33.341C-34.792,-18.803,-44.38,38.071,-43.283,47.879Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,587.013,452.691)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#102140",
    d: "M19.924,-8.435C19.924,-8.435,15.745,-29.625,-2.089,-20.779C-19.924,-11.932,-9.083,29.625,-9.083,29.625C-9.083,29.625,19.924,-8.435,19.924,-8.435Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,608.337,510.915)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#db6767",
    d: "M-4.816,-6.174C0.095,-1.648,5.008,0.52,5.008,0.52C5.008,0.52,4.624,6.174,4.624,6.174C4.624,6.174,-5.008,-3.02,-4.816,-6.174Z"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingOverview);
export default __webpack_public_path__ + "static/media/accounting-overview.85f7b4cbe747bacbb81503e8649a8039.svg";
export { ForwardRef as ReactComponent };